import React, { useState,Fragment } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { numberFormat, filterOut, numberWithCommasInput, findArrayObject, checkNumberOnly, validNumberCheck, numberWithCommas, capitalizeTheWord, replaceCommas, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis, validateDecimalNumber } from "../../../utils/utils";
import ConfirmDialog from '../Dialog/ConfirmDialog';
import NotesIcon from '@material-ui/icons/Notes';
import {
  getTripDetailsV3,
  getPartyList,
  getPartyListV2,
  getVehicleListV2,
  getSupplierListV2,
  getDriverListV2,
  createTrip,
  createLoad,
  updateTrip,
  editVendorExpense,
  emptyPartyList,
  updateNoteTrip,
  addNewNoteTrip,
  deleteTripNote,
  fetchTripDefaults,
  addVendorExpense,
  getJourneyDetails
} from "../../../store/actions/tripActionCreator";
import {
  getAllLocations, getTripLedgerData,
  getSuggestedDestinationLocations,
  getSuggestedOrginLocations
} from "../../../store/actions/homeActionCreator";
import {
  getVehicleLedgerData,
  getAllDrivers,
  getAllVendors
} from "../../../store/actions/vehicleActionCreator";
import {
  updateChatView
} from "../../../store/actions/userActionCreators";
import { sendError, sendSucces,isFunction } from "../../../utils/utils";
import RightSideBar from '../RightSideBar/RightSideBar';
import useMountEffect from '../../../mountEffect';
import { Form } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Autocomplete
} from 'mui-rff';
import AmountInput from '../Inputs/AmountInput';
import TextInputState from '../Inputs/TextInputState';
import * as logger from '../../../logger';
import { TruckIcon } from '../../../components/icons';

// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import clsx from 'clsx';
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import useStyles from '../css/addEditTrip'
import { Paper, InputAdornment } from '@material-ui/core';
import AddParty from '../../pages/Parties/AddParty';
import AddSupplier from '../../pages/Suppliers/AddSupplier';
import TripCompleteActionDialog from '../Trip/TripCompleteActionDialog';
import AddDriver from '../AddDialogComponent/AddDialogComponent';
import AddVehicle from '../../pages/Vehicles/AddVehicle';
import { trackDwebEvent } from '../../analytics';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import { updateFreeTrialModal } from '../../../store/actions/paymentsActionCreator';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import { debounce } from 'lodash';
import { Waypoint } from "react-waypoint";
import { useLogger } from '@material-ui/data-grid';
function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}
const filter = createFilterOptions({
  limit: 30
});
const AddEditLoadSideBar = (props) => {
  let submit, formValues;
  const { location, user,
    addLoad,
    lastTrip,
    trip, vehicle, tripId, sideBarOpen,
    vehicleDataFromSingleTruck,
    sideBarClose, sideBarTitle: sideBarTitleValue,
    dispatchTripDetailsAction,
    dispatchGetPartyListAction,
    dispatchGetVehicleListAction,
    dispatchGetVehicleLedgerAction,
    dispatchGetSupplierListAction,
    dispatchGetDriverListAction,
    dispatchGetAllLocations,
    dispatchGetAllSuggestedOrginLocations,
    dispatchGetAllSuggestedDestLocations,
    dispatchGetAllDrivers,
    dispatchGetAllVendors,
    dispatchUpdateTrip,
    dispatchEditVendorExpense,
    dispatchCreateLoad,
    dispatchEmptyPartyList,
    partyFromSingleParty,
    driverDataFromTruckBook,
    supplierDataFromTruckBook,
    dispatchChatView,
    dispatchUpdateNoteTrip,
    dispatchAddNoteTrip,
    dispatchDeleteTripNote,
    dispatchFetchTripDefaults,
    dispatchAddVendorExpense,
    editData,
    dispatchGetTripLedgerAction,
    dispatchUpdateModal,
    selectedTrip,
    updateJourney,
    onAddLoad
  } = props;
  const classes = useStyles();
  let history = useHistory();
  let fleetOwnerId = user.userInfo.entityId;
  const [open, setOpen] = React.useState(sideBarOpen);
  let journey = user.singleTripData?user.singleTripData:{};
  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(journey.id, () => {
    });
    // if (isFunction(updateJourney) && journey.id) {
    //   updateJourney(journey.id)
    // }
  }

  const getVehicle = (vehicleId) => {
    const vehicleValue = vehicleId ? vehicle && vehicle.vehicleLedgerData && vehicle.vehicleLedgerData.find(o => Number(o.id) === Number(vehicleId)) : null;
    return vehicleValue;
  }
  const getLocation = (name) => {
    const locationValue = name && user && user.allLocations ? user.allLocations.find(o => o.name === name) : null;
    return locationValue;
  }
  let today = new Date();
  let tripDetails = selectedTrip ? selectedTrip : {};
  let journeyId = journey&&journey.id?journey.id:null
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let hiredTrip = journey && journey.vehicle && journey.vehicle.ownershipType && journey.vehicle.ownershipType == 'HIRED' ? true : false
  let partyId = tripId && tripDetails && tripDetails.customer && tripDetails.customer.customerId ? tripDetails.customer.customerId : null;
  let vehicleVal = (addLoad || tripId) && journey && journey.vehicle && journey.vehicle.vehicleId ? journey.vehicle : null;
  let driverVal = (addLoad || tripId) && journey && journey.driver && journey.driver.driverId ? journey.driver : null;
  let startLocation = tripId && tripDetails && tripDetails.startLocation ? tripDetails.startLocation : addLoad&&lastTrip&&lastTrip.destinationLocation?lastTrip.destinationLocation:null;
  let destinationLocation = tripId && tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : null
  let party = tripId && tripDetails && tripDetails.customer ? tripDetails.customer : null;
  let vendorData = tripId && journey && journey.vendor ? journey.vendor : null;
  let tripNote = tripId && tripDetails && tripDetails.notes && tripDetails.notes.STARTED && tripDetails.notes.STARTED[0] ? tripDetails.notes.STARTED[0] : "";

  if (driverDataFromTruckBook) {
    driverVal = driverDataFromTruckBook;
  }

  const onConfirm = (create) => {
    setOpen(false);
    sideBarClose();
    dispatchChatView(true);
  }
  const onAddConfirm = (create) => {
    setOpen(false);
    sideBarClose();
    if(create && onAddLoad){
      onAddLoad()
    }
    dispatchChatView(true);
  }

  const goToTripView = (data) => {
    if (data && data.journeyId) {
      history.push({
        pathname: `/trips/view/${data.journeyId}`,
        state: {
          id: 7,
          tripData: data,
          tripView: true,
          pageTitle: 'Trip Details',
          pageSubTitle: data && data.vehicleNumber ? data.vehicleNumber : ''
        }
      })
    }
  }

  //Complete Trip
  const [completeTripOpen, setCompleteTripOpen] = React.useState(false);
  const [completeTripValue, setCompleteTripValue] = React.useState(null);
  const handleTripCompleteActionClose = (status) => {
    setCompleteTripOpen(status);
    if (completeTripValue && completeTripValue.type && completeTripValue.type == 'FV') {
      setVehicleValue(null);
    } else if (completeTripValue && completeTripValue.type && completeTripValue.type == 'FD') {
      setDriverValue(null);
    }
    setCompleteTripValue(null);
  }
  const handleTripCompleteActionConfirm = (status) => {
    setCompleteTripOpen(status);
    completeTripValue.tripId = null;
    if (completeTripValue && completeTripValue.type && completeTripValue.type == 'FV') {
      completeTripValue.status = 'Available'
      setVehicleValue(completeTripValue);
    } else if (completeTripValue && completeTripValue.type && completeTripValue.type == 'FD') {
      completeTripValue.status = 'Available'
      setDriverValue(completeTripValue);
    }
    setCompleteTripValue(null);
  }
  //Party
  const [partyValue, setPartyValue] = React.useState({
    ...party,
    name:party && party.customerName? party.customerName:'',
    id:party && party.customerId? party.customerId:''
  });
  const [partyInputValue, setPartyInputValue] = React.useState(null);
  const [partListOpen, setPartListOpen] = React.useState(false);
  const [addPartyOpen, toggleAddPartyOpen] = React.useState(false);
  const [currentPageNoParties,setCurrentPageNoParties]  = useState(1);
  const [currentPageSizeParties,setCurrentPageSizeParties]  = useState(10);
  const [partyDialogValue, setPartyDialogValue] = React.useState({
    name: '',
    number: '',
  });
  const [partyListoptions, setPartyListOptions] = React.useState([]);
  const partyListLoading = partListOpen && trip && trip.createTripParties && trip.createTripParties.parties && trip.createTripParties.parties.length === 0;
  const handleAddPartyClose = () => {
    setPartyDialogValue({
      name: '',
      number: '',
    });
    toggleAddPartyOpen(false);
  };
  const handlePartySave = (status, response) => {
    toggleAddPartyOpen(false);
    setPartyValue(response && response.customerId ? response : null);
  }
  const fetchParties = (search,pagination)=>{
    let req = {
      pageSize:defaultPageSize,
      pageNo:defaultPageNo,
    }
    if(pagination){
      req.pageNo = currentPageNoParties+1;
      req.merge = true;
    }
    if(search){
      req.search=search;
    }
    dispatchGetPartyListAction(req, () => { }, () => { })
  }
  const onSearchBlurParties = debounce(query => {
    setCurrentPageNoParties(defaultPageNo)
    fetchParties(query,false)
  }, user && user.configs && user.configs.dwebSearchBebounceMs?parseInt(user.configs.dwebSearchBebounceMs):defaultDebounceMs);
  //vehicle
  const [vehicleValue, setVehicleValue] = React.useState({
    ...vehicleVal,
    id:vehicleVal&&vehicleVal.vehicleId?vehicleVal.vehicleId:null
  });
  const [vehicleInputValue, setVehicleInputValue] = React.useState("");
  const [vehicleListOpen, setvehicleListOpen] = React.useState(false);
  const [vehicleListOptions, setVehicleListOptions] = React.useState([]);
  const vehicleLoading = vehicleListOpen && trip && trip.createTripVehicles && trip.createTripVehicles.trucks && trip.createTripVehicles.trucks.length === 0;
  const [addVehicleOpen, toggleAddVehicleOpen] = React.useState(false);
  const [vehicleDialogValue, setVehicleDialogValue] = React.useState({
    vehicleNumber: ''
  });
  const handleAddVehicleClose = () => {
    setVehicleDialogValue({
      vehicleNumber: '',
    });
    toggleAddVehicleOpen(false);
  };
  const handleVehicleSave = (status, response) => {
    toggleAddVehicleOpen(false);
    dispatchGetVehicleLedgerAction({
      fleetOwnerId: user.userInfo.entityId,
      ownershipType: ["SELF", "HIRED"],
      vehicleStatus: ["AVAILABLE", "ONTRIP"],
    }, () => {
      setVehicleValue(response && response.id ? response : null);
      if (response && response.driverId && response.driverName) {
        setDriverValue(response && response.driverId ? {
          id: response.driverId,
          name: response.driverName,
          fleetOwnerId: response.fleetOwnerId,
          contactNumber: response.driverNumber
        } : null);
      }
    })
  }

  const checkHiredTrip = (vehicleId) => {

    let vehicleData = vehicleId ? vehicle && vehicle.vehicleLedgerData && vehicle.vehicleLedgerData.find(o => Number(o.id) === Number(vehicleId)) : null;
    if (!vehicleData) {
      vehicleData = vehicleValue
    }

    return vehicleData && vehicleData.ownershipType && vehicleData.ownershipType == 'HIRED' ? true : false;
  }
  const [currentPageNoVehicle,setCurrentPageNoVehicle]  = useState(1);
  const [currentPageSizeVehicle,setCurrentPageSizeVehicle]  = useState(10);
  const fetchVehicles = (search,pagination)=>{
    let req = {
      pageSize:defaultPageSize,
      pageNo:defaultPageNo,
    }
    if(pagination){
      req.pageNo = currentPageNoVehicle+1;
      req.merge = true;
    }
    if(search){
      req.search=search;
    }
    dispatchGetVehicleListAction(req, () => { }, () => { })
  }
  const onSearchBlurVehicles = debounce(query => {
    setCurrentPageNoVehicle(defaultPageNo)
    fetchVehicles(query,false)
  }, user && user.configs && user.configs.dwebSearchBebounceMs?parseInt(user.configs.dwebSearchBebounceMs):defaultDebounceMs);

  //driver
  const [driverValue, setDriverValue] = React.useState({
    ...driverVal,
    name:driverVal && driverVal.driverName?driverVal.driverName:'',
    id:driverVal && driverVal.driverId?driverVal.driverId:'',
  });
  const [driverInputValue, setDriverInputValue] = React.useState(null);
  const [driverListOpen, setDriverListOpen] = React.useState(false);
  const [driverListOptions, setDriverListOptions] = React.useState([]);
  const driverLoading = driverListOpen &&  trip && trip.createTripDrivers && trip.createTripDrivers.drivers && trip.createTripDrivers.drivers.length === 0;
  const [addDriverOpen, toggleAddDriverOpen] = React.useState(false);
  const [driverDialogValue, setDriverDialogValue] = React.useState({
    name: '',
    number: '',
  });
  const handleAddDriverClose = () => {
    setDriverDialogValue({
      name: '',
      number: '',
    });
    toggleAddDriverOpen(false);
  };
  const handleDriverSave = (status, response) => {
    toggleAddDriverOpen(false);
    setDriverValue(response && response.id ? response : null);
  }
  const [currentPageNoDriver,setCurrentPageNoDriver]  = useState(1);
  const [currentPageSizeDriver,setCurrentPageSizeDriver]  = useState(10);
  const fetchDrivers = (search,pagination)=>{
    let req = {
      pageSize:defaultPageSize,
      pageNo:defaultPageNo,
    }
    if(pagination){
      req.pageNo = currentPageNoDriver+1;
      req.merge = true;
    }
    if(search){
      req.search=search;
    }
    dispatchGetDriverListAction(req, () => { }, () => { })
  }
  const onSearchBlurDrivers = debounce(query => {
    setCurrentPageNoDriver(defaultPageNo)
    fetchDrivers(query,false)
  }, user && user.configs && user.configs.dwebSearchBebounceMs?parseInt(user.configs.dwebSearchBebounceMs):defaultDebounceMs);
  //supplier
  let supplierVal = vehicleDataFromSingleTruck && vehicleDataFromSingleTruck.vendor ? vehicleDataFromSingleTruck.vendor : (tripId && journey && journey.vendor && journey.vendor.vendorId? journey.vendor : null);

  if (supplierDataFromTruckBook) {
    supplierVal = supplierDataFromTruckBook;
  }

  if (!supplierVal && vehicleValue && vehicleValue.vendor && vehicleValue.vendor.id) {
    supplierVal = vehicleValue.vendor
  }
  const [supplierValue, setSupplierValue] = React.useState(supplierVal);
  const [supplierInputValue, setSupplierInputValue] = React.useState(null);
  const [supplierListOpen, setSupplierListOpen] = React.useState(false);
  const [supplierListOptions, setSupplierListOptions] = React.useState([]);
  const supplierLoading = supplierListOpen && trip && trip.createTripSuppliers && trip.createTripSuppliers.suppliers && trip.createTripSuppliers.suppliers.length === 0;
  const [addSupplierOpen, toggleAddSupplierOpen] = React.useState(false);
  const [supplierDialogValue, setSupplierDialogValue] = React.useState({
    name: '',
    number: '',
  });
  const handleAddSupplierClose = () => {
    setSupplierDialogValue({
      name: '',
      number: '',
    });
    toggleAddSupplierOpen(false);
  };
  const handleSupplierSave = (status, response) => {
    toggleAddSupplierOpen(false);
    setSupplierValue(response && response.id ? response : null);
  }
  const [currentPageNoSupplier,setCurrentPageNoSupplier]  = useState(1);
  const [currentPageSizeSupplier,setCurrentPageSizeSupplier]  = useState(10);
  const fetchSuppliers = (search,pagination)=>{
    let req = {
      pageSize:defaultPageSize,
      pageNo:defaultPageNo,
    }
    if(pagination){
      req.pageNo = currentPageNoSupplier+1;
      req.merge = true;
    }
    if(search){
      req.search=search;
    }
    dispatchGetSupplierListAction(req, () => { }, () => { })
  }
  const onSearchBlurSuppliers = debounce(query => {
    setCurrentPageNoSupplier(defaultPageNo)
    fetchSuppliers(query,false)
  }, user && user.configs && user.configs.dwebSearchBebounceMs?parseInt(user.configs.dwebSearchBebounceMs):defaultDebounceMs);
  //Location
  const [sourceValue, setSourceValue] = React.useState({
    name: startLocation
  });
  const [destinationValue, setDestinationValue] = React.useState({
    name: destinationLocation
  });
  const [sourceInputValue, setSourceInputValue] = React.useState(null);
  const [destinationInputValue, setDestinationInputValue] = React.useState(null);
  const [sourceListOpen, setSourceListOpen] = React.useState(false);
  const [destinationListOpen, setDestinationListOpen] = React.useState(false);
  const [allLocations, setAllLocations] = React.useState([]);
  const sourceLoading = sourceListOpen && user && user.allLocations && user.allLocations.length === 0;
  const destinationLoading = destinationListOpen && (user && user.allLocations && user.allLocations.length === 0);
  const driverLedgerRequestData = {
    fleetOwnerId: user.userInfo.entityId,
    // pageNo: 1,
    // pageSize: 10,
  };
  //Other Trip Data
  const [partyBillingType, setPartyBillingType] = useState(tripId && tripDetails && tripDetails.invoicingType ? tripDetails.invoicingType : 'Fixed');
  const [vendorBillingType, setVendorBillingType] = useState(tripId && vendorData && vendorData.invoicingType ? vendorData.invoicingType : 'Fixed');
  const [totalUnits, setTotalUnits] = useState(tripId && tripDetails && tripDetails.invoicingCalc && tripDetails.invoicingCalc.totalUnits ? tripDetails.invoicingCalc.totalUnits : '');
  const [unitPrice, setUnitPrice] = useState(tripId && tripDetails && tripDetails.invoicingCalc && tripDetails.invoicingCalc.unitPrice ? numberWithCommas(tripDetails.invoicingCalc.unitPrice) : '');
  const [vendorTotalUnits, setVendorTotalUnits] = useState(tripId && journey && journey.vendor && journey.vendor.invoicingCalc && journey.vendor.invoicingCalc.totalUnits ? journey.vendor.invoicingCalc.totalUnits : '');
  const [vendorUnitPrice, setVendorUnitPrice] = useState(tripId && journey && journey.vendor && journey.vendor.invoicingCalc && journey.vendor.invoicingCalc.unitPrice ? numberWithCommas(journey.vendor.invoicingCalc.unitPrice) : '');
  const [tripStartDate, setTripStartDate] = useState(tripId && tripDetails && tripDetails.startDate ? new Date(Number(tripDetails.startDate*1000)) : new Date());
  const [tripCompletedDate, setTripCompletedDate] = useState(tripId && tripDetails && tripDetails.completedDate ? new Date(Number(tripDetails.completedDate * 1000)) : new Date());
  const [podReceivedDate, setPodReceivedDate] = useState(tripId && tripDetails && tripDetails.podReceivedAt ? new Date(Number(tripDetails.podReceivedAt * 1000)) : new Date());
  const [podSubmittedDate, setPodSubmittedDate] = useState(tripId && tripDetails && tripDetails.podSubmittedAt ? new Date(Number(tripDetails.podSubmittedAt*1000)) : new Date());
  const [freightAmount, setFreightAmount] = useState(tripId && tripDetails && tripDetails.transactions && tripDetails.transactions.freight && tripDetails.transactions.freight.totalAmount ? numberWithCommas(parseInt(tripDetails.transactions.freight.totalAmount)) : '');
  const [truckHireCost, setTruckHireCost] = useState(tripId && journey && journey.truckHireCost ? numberWithCommas(parseInt(journey.truckHireCost)) : '');
  const [driverName, setDriverName] = useState(tripId && tripDetails && tripDetails.driverName ? tripDetails.driverName : '');
  const [driverContactNumber, setDriverContactNumber] = useState(tripId && tripDetails && tripDetails.driverContactNumber ? tripDetails.driverContactNumber : '');
  const [startOdometerReading, setStartOdometerReading] = useState(tripId && tripDetails && tripDetails.startOdometerReading ? tripDetails.startOdometerReading : '');
  const [endOdometerReading, setEndOdometerReading] = useState(tripId && tripDetails && tripDetails.endOdometerReading ? tripDetails.endOdometerReading : '');
  const [moreDetailFlag, setMoreDetailFlag] = useState(false);
  const [materialValue, setMaterialValue] = useState(tripId && tripDetails && tripDetails.material ? tripDetails.material : "");
  const [lrNoValue, setLrNoValue] = useState(tripId && tripDetails && tripDetails.lrNumber ? tripDetails.lrNumber : "");
  const [errorsValue, setErrorsValue] = useState({});
  const [noteValue, setNoteValue] = useState("");

  React.useEffect(() => {

    if (!tripId) {
      dispatchFetchTripDefaults(
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log('Add Edit Trip SideBar', 'Get Trip Defaults Successfull');
            if (data.response && data.response.tripDefaults && data.response.tripDefaults.elrNumber) {
              setLrNoValue(data.response.tripDefaults.elrNumber);
            }
            if (data.response && data.response.tripDefaults && data.response.tripDefaults.startKM) {
              setStartOdometerReading(data.response.tripDefaults.startKM);
            }
          }
        },
        () => {
          logger.log('Add Edit Trip SideBar', 'Get Trip Defaults Failed');
        }
      )
    }

    if (tripId) {
      //setvehicleListOpen(true);
    }

  }, [sideBarOpen]);


  React.useEffect(() => {
    setSupplierValue(supplierVal);
  }, [supplierVal])

  React.useEffect(() => {

    let tripNote = {
      ...tripDetails.notes
    };

    // Assigning value to the notes.
    if (tripId && tripNote && tripNote.STARTED && tripNote.STARTED[0]) {
      tripNote = tripNote.STARTED[0];
      setNoteValue(tripNote.note);
    } else {
      setNoteValue("");
    }

  }, [user.singleTripData]);

  React.useEffect(() => {

    if (tripId && tripDetails && (tripDetails.material || tripDetails.elr_number || tripDetails.startOdometerReading || (tripDetails && tripDetails.notes && tripDetails.notes.STARTED && tripDetails.notes.STARTED[0]))) {
      setMoreDetailFlag(true)
    }

  }, [user.singleTripData])

  //Data Loading
  useMountEffect(() => {
    if (tripId) {
      fetchTrip(tripId);
    }
    if (!tripId) {
      trackDwebEvent("Dweb Trip Create Initiated", {})
    }
    /*dispatchGetPartyListAction(
      null,
      () => {
        dispatchGetVehicleLedgerAction({
          fleetOwnerId: user.userInfo.entityId,
          ownershipType: ["SELF", "HIRED"],
          vehicleStatus: ["AVAILABLE", "ONTRIP"],
        },
          (response) => {
            dispatchGetAllLocations(
              () => {
                dispatchGetAllDrivers(
                  () => {
                    dispatchGetAllVendors(() => {
                      //setPartyListOptions(trip && trip.createTripParties?trip.createTripParties:[]);
                      ///setVehicleListOptions(vehicle && vehicle.vehicleLedgerData?vehicle.vehicleLedgerData:[]);
                      //setAllLocations(user && user.allLocations?user.allLocations:[]);
                    }, () => {

                    });
                  }, () => {

                  });
              },
              () => {
              }
            );
          },
          () => {
          }
        );
      },
      () => {
      }
    );*/
  });
  const getGroupedLocation = (suggested, all) => {
    let combined = [...suggested, ...all]
    return combined;
  }
  const getGroupedTrucks = (trucks) => {
    if(!trucks){
      return []
    }
    let own = trucks.filter(truck => truck && truck.ownershipType && truck.ownershipType =='SELF');
    let market = trucks.filter(truck => truck && truck.ownershipType && truck.ownershipType =='HIRED');
    own.forEach(function(part, index, theArray) {
      theArray[index].truckMapper = "My Trucks";
    });
    market.forEach(function(part, index, theArray) {
      theArray[index].truckMapper = "Market Trucks";
    });
    let combined = [...own,...market]
    return combined;
  }
  React.useEffect(() => {
    let defaultRequest = {
      pageSize:defaultPageSize,
      pageNo:defaultPageNo
    }
    if (partListOpen) {
      dispatchGetPartyListAction(defaultRequest, () => { }, () => { })
    }
    if (vehicleListOpen) {
      /*dispatchGetVehicleLedgerAction({
        fleetOwnerId: user.userInfo.entityId,
        ownershipType: ["SELF", "HIRED"],
        vehicleStatus: ["AVAILABLE", "ONTRIP"],
      }, () => { }, () => { });*/
      dispatchGetVehicleListAction(defaultRequest, () => { }, () => { })
    }
    if (supplierListOpen) {
      //dispatchGetAllVendors(() => { }, () => { });
      dispatchGetSupplierListAction(defaultRequest, () => { }, () => { })
    }
    if (driverListOpen) {
      //dispatchGetAllDrivers(() => { }, () => { });
      dispatchGetDriverListAction(defaultRequest, () => { }, () => { })
    }
    if ((sourceListOpen || destinationListOpen) && (!user.allLocations || user && user.allLocations && user.allLocations.length === 0)) {
      dispatchGetAllLocations(() => { }, () => { });
    }
    if (sourceListOpen) {
      dispatchGetAllSuggestedOrginLocations({
        vehicle: formValues && formValues.vehicle && formValues.vehicle.id ? formValues.vehicle.id : null
      }, () => { }, () => { });
    }
    if (destinationListOpen) {
      dispatchGetAllSuggestedDestLocations({
        vehicle: formValues && formValues.vehicle && formValues.vehicle.id ? formValues.vehicle.id : null
      }, () => { }, () => { });
    }
  }, [partListOpen, vehicleListOpen, supplierListOpen, driverListOpen, sourceListOpen, destinationListOpen]);

  //Form
  const validate = values => {
    const errors = {};
    let hiredTrip = checkHiredTrip(values.vehicle && values.vehicle.id ? values.vehicle.id : null);
    if (!values.party) {
      errors.party = 'Please Select a Party';
    }
    if (!addLoad && !values.vehicle) {
      errors.vehicle = 'Select a Vehicle';
    }
    if (!addLoad && values.vehicle && !values.vehicle.id) {
      errors.vehicle = 'Select a Vehicle';
    }
    if (!values.supplier && hiredTrip) {
      errors.supplier = 'Select a Supplier';
    }
    /*if (!values.driver && !hiredTrip) {
      errors.driver = 'Select a Driver';
    }*/
    // if (!addLoad && values.driver && !hiredTrip && !values.driver.id) {
    //   errors.driver = 'Select a Driver';
    // }
    if (values.origin && !values.origin.name) {
      errors.origin = 'Origin Required';
    }
    if (values.destination && !values.destination.name) {
      errors.destination = 'Destination Required';
    }
    /*if (values.origin && values.origin.name && values.destination && values.destination.name && values.origin.name === values.destination.name) {
      errors.origin = 'origin and destination are same';
      errors.destination= 'origin and destination are same';;
    }*/
    if (!values.amount && values.partyBillingType == 'Fixed') {
      errors.amount = 'Freight Amount Required';
    }
    if (values.amount && values.partyBillingType == 'Fixed' && !validNumberCheck(values.amount)) {
      errors.amount = 'Invalid Freight Amount';
    }
    if (values.amount && values.partyBillingType == 'Fixed' && validNumberCheck(values.amount) && Number(replaceCommas(values.amount)) > 1000000) {
      errors.amount = 'Freight Amount should not be greater than 10 Laks';
    }
    if (!values.truckHireCost && values.vendorBillingType == 'Fixed' && hiredTrip) {
      errors.truckHireCost = 'Truck Hire Cost Required';
    }
    if (values.truckHireCost && values.vendorBillingType == 'Fixed' && hiredTrip && !validNumberCheck(values.truckHireCost)) {
      errors.truckHireCost = 'Invalid Truck Hire Cost';
    }
    if (values.truckHireCost && values.vendorBillingType == 'Fixed' && hiredTrip && validNumberCheck(values.truckHireCost) && Number(replaceCommas(values.truckHireCost)) > 1000000) {
      errors.truckHireCost = 'Truck Hire Cost should not be greater than 10 Laks ';
    }
    if (!values.startDate) {
      errors.startDate = 'Required';
    }
    if (values.startDate && values.party && values.party.openingBalanceDate && values.startDate < new Date(Number(values.party.openingBalanceDate)*1000)) {
      errors.startDate = 'Start Date should be greater than Opening Balance Date';
    }
    if (!values.partyBillingType) {
      errors.partyBillingType = 'Party Billing Type Required';
    }
    if (!values.unitPrice && values.partyBillingType != 'Fixed') {
      errors.unitPrice = 'Rate is required';
    }
    if (values.unitPrice && values.partyBillingType != 'Fixed' && !validNumberCheck(values.unitPrice)) {
      errors.unitPrice = 'Invalid rate';
    }
    if (!values.totalUnits && values.partyBillingType != 'Fixed') {
      errors.totalUnits = 'Total units required';
    }
    if (values.totalUnits && values.partyBillingType != 'Fixed' && !validNumberCheck(values.totalUnits)) {
      errors.totalUnits = 'Invalid total units';
    }
    if (values && values.startOdometerReading && !(/^[0-9]+$/).test(replaceCommas(values.startOdometerReading))) {
      errors.startOdometerReading = "Please enter a proper number. Decimals not allowed";
    }
    if (values && values.endOdometerReading && !(/^[0-9]+$/).test(replaceCommas(values.endOdometerReading))) {
      errors.endOdometerReading = "Please enter a proper number. Decimals not allowed";
    }
    if (!values.vendorBillingType && hiredTrip) {
      errors.vendorBillingType = 'Required';
    }
    if (!values.vendorUnitPrice && values.vendorBillingType != 'Fixed' && hiredTrip) {
      errors.vendorUnitPrice = 'Rate Required';
    }
    if (values.vendorUnitPrice && values.vendorBillingType != 'Fixed' && !validNumberCheck(values.vendorUnitPrice)) {
      errors.vendorUnitPrice = 'Invalid rate';
    }
    if (!values.vendorTotalUnits && values.vendorBillingType != 'Fixed' && hiredTrip) {
      errors.vendorTotalUnits = 'Total units required';
    }
    if (values.vendorTotalUnits && values.vendorBillingType != 'Fixed' && hiredTrip && !validNumberCheck(values.vendorTotalUnits)) {
      errors.vendorTotalUnits = 'Invalid total units';
    }
    /*if (values.driverContactNumber && hiredTrip && (!checkNumberOnly(values.driverContactNumber) || values.driverContactNumber.length != 10)) {
      errors.driverContactNumber = 'Enter Valid Contact Number';
    }*/
    /*if (values.driverContactNumber && hiredTrip) {
      if (isNaN(values.driverContactNumber)) {
        errors.driverContactNumber = 'Number Only';
      }else if (values.driverContactNumber.length!=10) {
        errors.driverContactNumber = 'Enter Valid Number';
      }
    }*/

    return errors;
  };
  const updateTruckHireCost = (values) => {

    if (journey && journey.vendorTransactions && journey.vendorTransactions.charges && journey.vendorTransactions.charges.list) {
      let updateData = {}
      let hireCostExpense = findArrayObject('transactionType', 'Vehicle_Hire_Cost', journey.vendorTransactions.charges.list);
      if (hireCostExpense && hireCostExpense.id) {
        updateData = {
          ...hireCostExpense,
          fleetOwnerId: fleetOwnerId,
          expenseDate: Number(hireCostExpense.expenseDate),
          tripId: tripId,
          vendorId: values.supplier.id,
          amount: Number(replaceCommas(values.truckHireCost))
        }
        updateData['vendorBillingType'] = values.vendorBillingType;
        if (values.vendorBillingType != 'Fixed') {
          updateData['vendorBillingDetails'] = { unitPrice: Number(replaceCommas(values.vendorUnitPrice)), totalUnits: Number(values.vendorTotalUnits) }
          updateData['amount'] = Number(values.vendorUnitPrice ? replaceCommas(values.vendorUnitPrice) : 0) * Number(values.vendorTotalUnits ? values.vendorTotalUnits : 0);
        }
        dispatchEditVendorExpense(updateData.id, updateData, (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            sendSucces("Trip Updated Successfully!");
            onConfirm()
          } else {
          }
        },
          () => {
          })
      } else {

        let updateData = {
          fleetOwnerId: fleetOwnerId,
          expenseType: 'Vehicle_Hire_Cost',
          expenseDate: Math.round(new Date().getTime() / 1000),
          tripId: tripId,
          vendorId: values.supplier.id,
          amount: Number(replaceCommas(values.truckHireCost))
        }

        updateData['vendorBillingType'] = values.vendorBillingType;
        if (values.vendorBillingType != 'Fixed') {
          updateData['vendorBillingDetails'] = { unitPrice: Number(replaceCommas(values.vendorUnitPrice)), totalUnits: Number(values.vendorTotalUnits) }
          updateData['amount'] = Number(values.vendorUnitPrice ? replaceCommas(values.vendorUnitPrice) : 0) * Number(values.vendorTotalUnits ? values.vendorTotalUnits : 0);
        }

        dispatchAddVendorExpense(updateData, (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            sendSucces("Trip Updated Successfully!");
            onConfirm()
          } else {

          }
        },
          () => {

          })

      }
    }
  }

  const handleTripNotes = (values) => {

    if (tripNote && tripNote.id && values && values.notes && values.notes.trim()) {

      dispatchUpdateNoteTrip(
        tripId,
        tripNote.id,
        {
          note: values.notes ? values.notes.trim() : ""
        },
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log('Add Edit Trip SideBar', 'Update Note Successfull');
          }
        },
        () => {
          logger.log('Add Edit Trip SideBar', 'Update Note Failed');
        }
      );
    } else if (tripNote && tripNote.id && values && !values.notes && !values.notes.trim()) {

      dispatchDeleteTripNote(
        tripDetails.id,
        tripNote.id,
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log('Add Edit Trip SideBar', 'Delete Note Successfull');
          }
        },
        () => {
          logger.log('Add Edit Trip SideBar', 'Delete Note Failed');
        }
      );

    } else if (values.notes && values.notes.trim()) {
      let notesValue = [];

      notesValue.push({
        note: noteValue.trim(),
        noteReceivedDate: Math.round((today.getTime() / 1000))
      })

      dispatchAddNoteTrip(
        tripDetails.id,
        {
          notes: notesValue,
          tripStatus: "STARTED",
          fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
          fleet_owner_id: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
          fo_id: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
        },
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log('Add Edit Trip SideBar', 'Add Note Successfull');
          }
        },
        () => {
          logger.log('Add Edit Trip SideBar', 'Add Note Failed');
        }
      )
    }
  }

  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    let hiredTrip = checkHiredTrip(values.vehicle && values.vehicle.id ? values.vehicle.id : null);
    //window.alert(JSON.stringify(values, 0, 2));
    if (tripId) {
      let updateTrip = {
        tripStartDate: Math.round(((new Date(values.startDate).setHours(0, 0, 0, 0)) / 1000)),
        totalAmount: Number(replaceCommas(values.amount)),
        customerId: values.party.customerId,
        destinationLocation: values.destination.name,
        sourceLocation: values.origin.name,
        vehicleId: values.vehicle.id,
        fleetOwnerId: user.userInfo.entityId,
        billingType: values.partyBillingType,
        startOdometerReading: Number(replaceCommas(values.startOdometerReading)),
        material: values.material ? values.material : "",
        lrNumber: values.lrNo ? (values.lrNo).toUpperCase() : "",
        //endOdometerReading: Number(replaceCommas(values.startOdometerReading)),
      };
      if (values.completedDate && (tripStatus && (tripStatus == "COMPLETED" || tripStatus == "POD_RECEIVED" || tripStatus == "POD_SUBMITTED"))) {
        updateTrip['tripCompletedDate'] = Math.round((values.completedDate.setHours(0, 0, 0, 0) / 1000));
      }
      if (values.podReceivedDate && (tripStatus && (tripStatus == "POD_RECEIVED" || tripStatus == "POD_SUBMITTED"))) {
        updateTrip['podReceivedDate'] = Math.round((values.podReceivedDate.setHours(0, 0, 0, 0) / 1000));
      }
      if (values.podSubmittedDate && (tripStatus && (tripStatus == "POD_SUBMITTED"))) {
        updateTrip['podSubmittedDate'] = Math.round((values.podSubmittedDate.setHours(0, 0, 0, 0) / 1000));
      }
      if (values.endOdometerReading && (tripStatus && (tripStatus == "COMPLETED" || tripStatus == "POD_RECEIVED" || tripStatus == "POD_SUBMITTED"))) {
        updateTrip['endOdometerReading'] = Number(replaceCommas(values.endOdometerReading));
      }
      if (values.partyBillingType != 'Fixed') {
        updateTrip['billingDetails'] = { unitPrice: Number(replaceCommas(values.unitPrice)), totalUnits: Number(values.totalUnits) }
        updateTrip['totalAmount'] = Number(values.unitPrice ? replaceCommas(values.unitPrice) : 0) * Number(values.totalUnits ? values.totalUnits : 0);
      }
      if (hiredTrip) {
        if(values && values.vehicle && values.vehicle.id && values.vehicle.driverId){
          updateTrip['driverId'] = values.vehicle.driverId
        }
        //updateTrip['driverName'] = values.driverName;
        //updateTrip['driverContactNumber'] = values.driverContactNumber;
      } else {
        if (values.driver && values.driver.id) {
          updateTrip['driverId'] = values.driver && values.driver.id ? values.driver.id : null;
        }
      }

      // if (!tripNote && !tripNote.id) {
      //   updateTrip.notes = [
      //     {
      //       note: values.notes ? values.notes : "",
      //       s3Link: "",
      //       noteReceivedDate: Math.round((new Date()).getTime() / 1000)
      //     }
      //   ]
      // }

      handleTripNotes(values);

      dispatchUpdateTrip(
        tripId,
        updateTrip,
        (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            if (hiredTrip) {
              updateTruckHireCost(values)
            } else {
              sendSucces("Trip Updated Successfully!");
              onConfirm();
            }

            // else {
            //   sendSucces("Trip Updated Successfully!");
            //   onConfirm()
            // }
            // dispatchTripDetailsAction(tripId,
            //   (data) => {
            //     if (data && data.status && data.status.code == 200) {
            //       logger.log("Add Edit Trip SideBar", 'Get Trip Details Successfull');
            //     }
            //   },
            //   () => {

            //   });


          }
        },
        () => {

        },
      );

    } else {
      let createTripData = {
        totalAmount: Number(replaceCommas(values.amount)),
        tripStartDate: Math.round(((new Date(values.startDate).setHours(0, 0, 0, 0)) / 1000)),
        customerId: values && values.party && values.party.customerId ? values.party.customerId : "",
        destinationLocation: values && values.destination && values.destination.name ? values.destination.name : "",
        sourceLocation: values && values.origin && values.origin.name ? values.origin.name : "",
        //vehicleId: values.vehicle.id,
        fleetOwnerId: user.userInfo.entityId,
        billingType: values.partyBillingType,
        startOdometerReading: Number(replaceCommas(values.startOdometerReading)),
        material: values.material ? values.material : "",
        lrNumber: values.lrNo ? (values.lrNo).toUpperCase() : "",
        notes: [
          {
            note: values.notes ? values.notes : "",
            s3Link: "",
            noteReceivedDate: Math.round((new Date()).getTime() / 1000)
          }
        ]
      }
      if (values.partyBillingType != 'Fixed') {
        createTripData['billingDetails'] = { unitPrice: Number(replaceCommas(values.unitPrice)), totalUnits: Number(values.totalUnits) }
        createTripData['totalAmount'] = Number(values.unitPrice ? replaceCommas(values.unitPrice) : 0) * Number(values.totalUnits ? values.totalUnits : 0);
      }
      if (hiredTrip) {
        if(values && values.vehicle && values.vehicle.id && values.vehicle.driverId){
          updateTrip['driverId'] = values.vehicle.driverId
        }
        //createTripData['driverName'] = values.driverName;
        //createTripData['driverContactNumber'] = values.driverContactNumber;
        createTripData['vendorTransactions'] = {};
        createTripData.vendorTransactions.vendorId = values.supplier.id;
        createTripData.vendorTransactions.vehicleHireCost = Number(replaceCommas(values.truckHireCost));
        createTripData.vendorTransactions.vendorBillingType = values.vendorBillingType;
        if (values.vendorBillingType != 'Fixed') {
          createTripData['vendorTransactions']['vendorBillingDetails'] = { unitPrice: Number(replaceCommas(values.vendorUnitPrice)), totalUnits: Number(values.vendorTotalUnits) }
          createTripData['vendorTransactions']['vehicleHireCost'] = Number(values.vendorUnitPrice ? replaceCommas(values.vendorUnitPrice) : 0) * Number(values.vendorTotalUnits ? values.vendorTotalUnits : 0);
        }
      } else {
        if (values.driver && values.driver.id) {
          //createTripData['driverId'] = values.driver && values.driver.id ? values.driver.id : null;
        }
      }
      dispatchCreateLoad(
        journeyId,
        createTripData,
        (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            sendSucces('Load created successfully');
            let data = response.response;
            trackDwebEvent('Dweb Load Create', {
              trip_id: data && data.id ? data.id : '',
              party_id: values && values.party && values.party.customerId ? values.party.customerId : '',
              party_name: values && values.party && values.party.name ? values.party.name : '',
              vehicle_id: values && values.vehicle && values.vehicle.id ? values.vehicle.id : '',
              vehicle_number: values && values.vehicle && values.vehicle.vehicleNumber ? values.vehicle.vehicleNumber : '',
              trip_status: data && data.status ? data.status : ''
            })
            onAddConfirm(true);
            goToTripView(response.response)
          }
        },
        () => {
        }
      )
    }

  };

  let initialValues = {
    partyBillingType: partyBillingType,
    vendorBillingType: vendorBillingType,
    party: partyValue,
    vehicle: vehicleValue,
    supplier: supplierValue,
    driver: driverValue,
    origin: sourceValue,
    destination: destinationValue,
    startDate: new Date(),
    totalUnits: totalUnits,
    unitPrice: unitPrice,
    vendorTotalUnits: vendorTotalUnits,
    vendorUnitPrice: vendorUnitPrice,
    startDate: tripStartDate,
    completedDate: tripCompletedDate,
    podReceivedDate: podReceivedDate,
    podSubmittedDate: podSubmittedDate,
    amount: freightAmount,
    truckHireCost: truckHireCost,
    //driverName:driverName,
    //driverContactNumber:driverContactNumber,
    startOdometerReading: startOdometerReading,
    endOdometerReading: endOdometerReading,
    lrNo: lrNoValue,
    material: materialValue,
    notes: noteValue
  };

  /*if (tripId) {
    initialValues.driver=driverId;
    initialValues.origin=startLocation;
    initialValues.destination=destinationLocation;
    initialValues.partyBillingType = tripDetails && tripDetails.billingType ? tripDetails.billingType : 'Fixed';

    initialValues.totalUnits=tripDetails&&tripDetails.billingDetails && tripDetails.billingDetails.totalUnits?tripDetails.billingDetails.totalUnits:'';
    initialValues.unitPrice=tripDetails&&tripDetails.billingDetails && tripDetails.billingDetails.unitPrice?numberWithCommas(tripDetails.billingDetails.unitPrice):'';
    initialValues.vendorBillingType=tripDetails&&tripDetails.vendorBillingType?tripDetails.vendorBillingType:'Fixed';
    initialValues.vendorTotalUnits=tripDetails&&tripDetails.vendorBillingDetails && tripDetails.vendorBillingDetails.totalUnits?tripDetails.vendorBillingDetails.totalUnits:'';
    initialValues.vendorUnitPrice=tripDetails&&tripDetails.vendorBillingDetails && tripDetails.vendorBillingDetails.unitPrice?numberWithCommas(tripDetails.vendorBillingDetails.unitPrice):'';
    initialValues.startDate=tripDetails && tripDetails.startDate?new Date(tripDetails.startDate):new Date();
    initialValues.completedDate=tripDetails && tripDetails.completedDate?new Date(tripDetails.completedDate):new Date();
    initialValues.podReceivedDate=tripDetails && tripDetails.podReceivedAt?new Date(tripDetails.podReceivedAt):new Date();
    initialValues.podSubmittedDate=tripDetails && tripDetails.podSubmittedAt?new Date(tripDetails.podSubmittedAt):new Date();
    initialValues.amount=tripDetails && tripDetails.freightAmount?numberWithCommas(parseInt(tripDetails.freightAmount)):'';
    initialValues.truckHireCost=tripDetails && tripDetails.truckHireCost?numberWithCommas(parseInt(tripDetails.truckHireCost)):'';
    initialValues.driverName=tripDetails && tripDetails.driverName?tripDetails.driverName:''
    initialValues.driverContactNumber=tripDetails && tripDetails.driverContactNumber?tripDetails.driverContactNumber:'';
    initialValues.startOdometerReading=tripDetails && tripDetails.startOdometerReading?tripDetails.startOdometerReading:'';
    initialValues.endOdometerReading=tripDetails && tripDetails.endOdometerReading?tripDetails.endOdometerReading:''
  }*/
  const [tripValues, setTripValues] = React.useState(initialValues);
  /*const partyDefaultValue = initialValues.party ? partyListoptions.find(o => o.customerId === initialValues.party):null;
  const vehicleDefaultValue = initialValues.vehicle ? vehicle && vehicle.vehicleLedgerData.find(o => Number(o.id) === Number(initialValues.vehicle)):null;
  const driverDefaultValue = initialValues.driver ? vehicle && vehicle.drivers.find(o => Number(o.id) === Number(initialValues.driver)):null;
  const supplierDefaultValue = initialValues.supplier ? vehicle && vehicle.vendors.find(o => Number(o.id) === Number(initialValues.supplier)):null;
  const originDefaultValue = initialValues.origin ? user && user.allLocations && user.allLocations.find(o => o.name === initialValues.origin):null;
  const destinationDefaultValue = initialValues.destination ? user && user.allLocations && user.allLocations.find(o => o.name === initialValues.destination):null;*/

  const getFormFields = (values) => {


    let hiredTrip = checkHiredTrip(values.vehicle && values.vehicle.id ? values.vehicle.id : null);
    let { partyBillingType, vendorBillingType } = values;
    let unitsPriceLabel = "";
    let totalUnitsLabel = "";
    let vendorUnitsPriceLabel = "";
    let vendorTotalUnitsLabel = "";
    let freightAmountCard = "Freight Amount";
    let truckHireCostCard = "Truck Hire Cost";
    if (partyBillingType === 'Per Tonne') {
      unitsPriceLabel = 'Rate Per Tonne';
      totalUnitsLabel = 'Total Tonnage';
      freightAmountCard += " (Rate * Number of Tonnes)"
    } else if (partyBillingType === 'Per KG') {
      unitsPriceLabel = 'Rate Per Kg';
      totalUnitsLabel = 'Total Kg'
      freightAmountCard += " (Rate * Number of Kg)"
    } else if (partyBillingType === 'Per KM') {
      unitsPriceLabel = 'Rate Per Km';
      totalUnitsLabel = 'Total Km'
      freightAmountCard += " (Rate * Number of Km)"
    } else if (partyBillingType == "Per Trip") {
      unitsPriceLabel = 'Rate Per Trip'
      totalUnitsLabel = 'Total Trips'
      freightAmountCard += " (Rate * Number of Trips)"
    } else if (partyBillingType == "Per Day") {
      unitsPriceLabel = 'Rate Per Day'
      totalUnitsLabel = 'Total Days'
      freightAmountCard += " (Rate * Number of Days)"
    } else if (partyBillingType == "Per Hour") {
      unitsPriceLabel = 'Rate Per Hour'
      totalUnitsLabel = 'Total Hours'
      freightAmountCard += " (Rate * Number of Hours)"
    } else if (partyBillingType == "Per Litre") {
      unitsPriceLabel = 'Rate Per Litre'
      totalUnitsLabel = 'Total Litres'
      freightAmountCard += " (Rate * Number of Litres)"
    } else if (partyBillingType == "Per Bag") {
      unitsPriceLabel = "Rate Per Bag"
      totalUnitsLabel = "Total Bags"
      freightAmountCard += " (Rate * Number of Bags)"
    }
    if (vendorBillingType === 'Per Tonne') {
      vendorUnitsPriceLabel = 'Rate Per Tonne';
      vendorTotalUnitsLabel = 'Total Tonnage';
      truckHireCostCard += " (Rate * Number of Tonnes)"

    } else if (vendorBillingType === 'Per KG') {
      vendorUnitsPriceLabel = 'Rate Per Kg';
      vendorTotalUnitsLabel = 'Total Kg'
      truckHireCostCard += " (Rate * Number of Kg)"

    } else if (vendorBillingType === 'Per KM') {
      vendorUnitsPriceLabel = 'Rate Per Km';
      vendorTotalUnitsLabel = 'Total Km'
      truckHireCostCard += " (Rate * Number of Km)"
    } else if (vendorBillingType == "Per Trip") {
      vendorUnitsPriceLabel = 'Rate Per Trip'
      vendorTotalUnitsLabel = 'Total Trips'
      truckHireCostCard += " (Rate * Number of Trips)"
    } else if (vendorBillingType == "Per Day") {
      vendorUnitsPriceLabel = 'Rate Per Day'
      vendorTotalUnitsLabel = 'Total Days'
      truckHireCostCard += " (Rate * Number of Days)"
    } else if (vendorBillingType == "Per Hour") {
      vendorUnitsPriceLabel = 'Rate Per Hour'
      vendorTotalUnitsLabel = 'Total Hours'
      truckHireCostCard += " (Rate * Number of Hours)"
    } else if (vendorBillingType == "Per Litre") {
      vendorUnitsPriceLabel = 'Rate Per Litre'
      vendorTotalUnitsLabel = 'Total Litres'
      truckHireCostCard += " (Rate * Number of Litres)"
    } else if (vendorBillingType == "Per Bag") {
      vendorUnitsPriceLabel = "Rate Per Bag"
      vendorTotalUnitsLabel = "Total Bags"
      truckHireCostCard += "(Rate * Number of Bags)"
    }

    return [
      {
        size: 12,
        visible: true,
        field: (
          <>
            <div className={classes.titleV4}>Select Party *</div>
            <Autocomplete
              classes={{
                listbox: classes.listBoxAutoCompelete,
                option: classes.listBoxOption
              }
              }
              className={classes.textV1}
              id="select-party-list"
              //label="Party"
              name="party"
              size="small"
              disabled={tripId ? false : false}
              value={partyValue}
              onOpen={() => {
                setPartListOpen(true)
              }}
              onClose={() => {
                setPartListOpen(false)
              }}
              //placeholder="Select a Party"
              onChange={(event, newValue) => {
                //createNewParty(newValue)
                if (typeof newValue === 'string') {
                  // timeout to avoid instant validation of the dialog's form.
                  setTimeout(() => {
                    setPartyValue(null);
                    toggleAddPartyOpen(true);
                    setPartyDialogValue({
                      name: !checkNumberOnly(newValue) ? capitalizeTheWord(newValue) : "",
                      number: checkNumberOnly(newValue) ? newValue : "",
                    });
                  });
                } else if (newValue && newValue.inputValue) {
                  setPartyValue(null);
                  toggleAddPartyOpen(true);
                  setPartyDialogValue({
                    name: !checkNumberOnly(newValue.inputValue) ? capitalizeTheWord(newValue.inputValue) : "",
                    number: checkNumberOnly(newValue.inputValue) ? newValue.inputValue : "",
                  });
                } else if (newValue && newValue.inputValue === '') {
                  setPartyValue(null);
                  toggleAddPartyOpen(true);
                  setPartyDialogValue({
                    name: "",
                    number: "",
                  });
                } else {
                  setPartyValue(newValue && newValue.customerId ? newValue : null);
                }
              }}
              //getOptionSelected={(option, value) => option && option.customerId === (value || value.customerId)}
              required={true}
              autoHighlight
              //freeSolo
              options={trip && trip.createTripParties && trip.createTripParties.parties ?trip.createTripParties.parties : []}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              getOptionValue={option => option.customerId}
              //getOptionLabel={option => option.name}
              getOptionLabel={(option) => {
                // e.g value selected with enter, right from the input
                if (typeof option === 'string') {
                  return '';
                }
                if (option.inputValue || !option.customerId) {
                  return '';
                }
                return option.name
              }}
              disableCloseOnSelect={false}
              filterOptions={(options, params) => {
                /*const filtered = filter(options, params);
                filtered.unshift({
                  inputValue: params.inputValue,
                  name: params.inputValue && params.inputValue.length > 1 ? `Add Details for "${capitalizeTheWord(params.inputValue)}"` : `Add New Party`,
                });*/
                  let filtered =[]
                  options.forEach((item,index)=>{
                    filtered.push({
                      ...item,
                      index:index
                    })
                  });
                    filtered.unshift({
                      inputValue: params.inputValue,
                      name: params.inputValue && params.inputValue.length > 1 ? `Add "${params.inputValue}"` : `Add New Party`,
                      add: true
                    });
                return filtered;
              }}
              filterSelectedOptions
              renderOption={(option, { selected, inputValue }) => {
                let matchesName, matchesNumber;
                let partsName, partsNumber;
                matchesName = match(option.name, inputValue);
                partsName = parse(option.name, matchesName);
                matchesNumber = match(option.contactNumber, inputValue);
                partsNumber = parse(option.contactNumber, matchesNumber);

                if (option && option.customerId) {
                  let list = trip && trip.createTripParties && trip.createTripParties.parties?trip.createTripParties.parties:[]
                  if (option.index == list.length-1) {
                    return(<Fragment>
                            <Waypoint
                              onEnter={() => {
                                if(trip && trip.createTripParties && trip.createTripParties.maxPage && trip.createTripParties.maxPage != currentPageNoParties){
                                  setCurrentPageNoParties(currentPageNoParties+1)
                                  fetchParties(option.inputValue,true)
                                }
                              }}
                            />
                            <div className={classes.partyListItemV1}>
                              <div className={classes.partyListItemFlex}>
                              <span className={classes.partyListNameFlex}>{partsName.map((part, index) => {
                                return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                  {part.text}
                                </span>
                                )
                              })}</span>
                              {option.contactNumber && <>
                                <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                {partsNumber.map((part, index) => {
                                  return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                    {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                                  </span>
                                  )
                                })}
                              </>}
                              </div>
                            </div>
                      </Fragment>)
                  }else{
                    return (
                      <div className={classes.partyListItemV1}>
                        <div className={classes.partyListItemFlex}>
                        <span className={classes.partyListNameFlex}>{partsName.map((part, index) => {
                          return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                            {part.text}
                          </span>
                          )
                        })}</span>
                        {option.contactNumber && <>
                          <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                          {partsNumber.map((part, index) => {
                            return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                              {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                            </span>
                            )
                          })}
                        </>}
                        </div>
                      </div>
                    );
                  }

                } else {
                  return (
                    <div className={classes.partyAddListItem}>
                      <AddPersonIcon className={classes.addPersonIcon} />
                      {partsName.map((part, index) => {
                        return (<span key={index} style={{ color: index == 0 ? '#0033cc' : 'black' }}>
                          {part.text}
                        </span>
                        )
                      })}
                      <ChevronRightIcon className={classes.cherveRightIcon} />
                    </div>
                  );
                }

              }}
              //inputValue={partyInputValue}
              onInputChange={(e,val)=>{
                onSearchBlurParties(val,false)
              }}
              textFieldProps={
                {
                  placeholder: "Eg: Arjun Reddy",
                  variant: "outlined",
                  margin: 'none',
                  name: "party",
                }
              }
              /*renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select a Party"
                  placeholder="Select a Party"
                  variant="outlined"
                  name="party"
                  margin='normal'
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {partyListLoading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}*/
              multiple={false}
            />
          </>
        ),
      },
      {
        size: hiredTrip ? 12 : 12,
        visible: true,
        field: (
          <>
            <div className={classes.divRow}>
              <div className={classes.widthV1}>
                <div className={classes.titleV2}>Truck Registration No.*</div>
                <Autocomplete
                  classes={{
                    listbox: classes.listBoxAutoCompelete,
                    option: classes.listBoxOption
                  }
                  }
                  disabled={(addLoad || tripId) ? true : false}
                  className={classes.mtV1}
                  id="select-vehicle-list"
                  open={vehicleListOpen}
                  onOpen={() => {
                    setvehicleListOpen(true)
                  }}
                  onClose={() => {
                   setvehicleListOpen(false)

                  }}
                  onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                      // timeout to avoid instant validation of the dialog's form.
                      setVehicleValue(null);
                      toggleAddVehicleOpen(true);
                      setVehicleDialogValue({
                        vehicleNumber: newValue.toUpperCase()
                      });
                    } else if (newValue && newValue.inputValue) {
                      setVehicleValue(null);
                      toggleAddVehicleOpen(true);
                      setVehicleDialogValue({
                        vehicleNumber: newValue.inputValue.toUpperCase()
                      });
                    } else if (newValue && newValue.inputValue === '') {
                      setVehicleValue(null);
                      toggleAddVehicleOpen(true);
                      setVehicleDialogValue({
                        vehicleNumber: ''
                      });
                    } else {
                      // if (newValue && newValue.status && newValue.status === 'On Trip') {
                      //   setVehicleValue(null);
                      //   newValue.type = 'FV'
                      //   setCompleteTripValue(newValue);
                      //   setCompleteTripOpen(true);
                      // } else {
                      setVehicleValue(newValue && newValue.id ? newValue : null);
                      if (newValue && newValue.id && newValue.vendor && newValue.vendor.id) {
                        setSupplierValue(newValue.vendor);
                      }
                      if (newValue && newValue.id && newValue.driver && newValue.driver.id) {
                        setDriverValue(newValue.driver);
                      }
                      // }
                    }
                  }}
                  name="vehicle"
                  size="small"
                  /*getOptionSelected={(option, value) =>{
                    return option.id === value.id && value.status != 'ONTRIP'
                  }}*/
                  required={true}
                  value={vehicleValue}
                  //groupBy={(option) => option.truckMapper}
                  autoHighlight
                  //freeSolo
                  options={trip && trip.createTripVehicles && trip.createTripVehicles.trucks ?trip.createTripVehicles.trucks : []}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  filterSelectedOptions
                  getOptionValue={option => option.id}
                  getOptionLabel={(option) => {
                    // e.g value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return '';
                    }
                    if (option.inputValue || !option.id) {
                      return '';
                    }
                    return option.vehicleNumber
                  }}
                  disableCloseOnSelect={false}
                  filterOptions={(options, params) => {
                    //const filtered = filter(options, params);
                    let filtered =[]
                    options.forEach((item,index)=>{
                      filtered.push({
                        ...item,
                        index:index
                      })
                    });
                    filtered.unshift({
                      inputValue: params.inputValue,
                      vehicleNumber: params.inputValue && params.inputValue.length > 1 ? `Add Details for '${params.inputValue.toUpperCase()}'` : `Add New Vehicle`,
                    });
                    return filtered;
                  }}
                  renderOption={(option, { selected, inputValue }) => {

                    const vehicleNumberValue = option && option.vehicleNumber ? option.vehicleNumber.split(/'/) : option.vehicleNumber;

                    if (vehicleNumberValue && vehicleNumberValue.length > 0 && !vehicleNumberValue.includes("Add New Vehicle")) {
                      vehicleNumberValue.pop();
                    }

                    if (option && option.id) {
                      let list = trip && trip.createTripVehicles && trip.createTripVehicles.trucks?trip.createTripVehicles.trucks:[]
                      if (option.index == list.length-1) {
                        return(<Fragment>
                                <Waypoint
                                  onEnter={() => {
                                    if(trip && trip.createTripVehicles && trip.createTripVehicles.maxPage && trip.createTripVehicles.maxPage != currentPageNoVehicle){
                                      setCurrentPageNoVehicle(currentPageNoVehicle+1)
                                      fetchVehicles(option.inputValue,true)
                                    }
                                  }}
                                />
                                 <div className={classes.vehicleListItem}>
                                    <div className={classes.divVehicleListing}>
                                      <span>{option.vehicleNumberPrefix}
                                        <span className={classes.vehicleNumberSuffix}>{option.vehicleNumberSuffix}</span>
                                        {option.lastLocation && <>
                                          <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                          {option.lastLocation}
                                        </>}
                                      </span>
                                    </div>
                                    <div className={classes.vehicleListItemFlex}>
                                      <div className={classes.ownershipType}>
                                        <span className={option.ownershipType && option.ownershipType == 'HIRED' ? classes.hired : classes.own}>{option.ownershipType && option.ownershipType == 'HIRED' ? 'Market' : 'Own'}</span>
                                      </div>
                                      <div className={classes.vehicleStatus}><span>{option.status}</span><FiberManualRecordIcon className={option.status && option.status == 'ONTRIP' ? classes.onTripBullet : classes.avilableBullet}></FiberManualRecordIcon></div>
                                    </div>
                                  </div>
                              </Fragment>);
                      }else{
                          return (
                            <div className={classes.vehicleListItem}>
                              <div className={classes.divVehicleListing}>
                                <span>{option.vehicleNumberPrefix}
                                  <span className={classes.vehicleNumberSuffix}>{option.vehicleNumberSuffix}</span>
                                  {option.lastLocation && <>
                                    <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                    {option.lastLocation}
                                  </>}
                                </span>
                              </div>
                              <div className={classes.vehicleListItemFlex}>
                                <div className={classes.ownershipType}>
                                  <span className={option.ownershipType && option.ownershipType == 'HIRED' ? classes.hired : classes.own}>{option.ownershipType && option.ownershipType == 'HIRED' ? 'Market' : 'Own'}</span>
                                </div>
                                <div className={classes.vehicleStatus}><span>{option.status}</span><FiberManualRecordIcon className={option.status && option.status == 'ONTRIP' ? classes.onTripBullet : classes.avilableBullet}></FiberManualRecordIcon></div>
                              </div>
                            </div>
                          );
                      }
                    } else {
                      return (
                        <div className={classes.partyAddListItem}>
                          <TruckIcon className={classes.truckIcon} />
                          {vehicleNumberValue && vehicleNumberValue.map((value, index) => (
                            <span style={{ color: index == 0 ? '#0033cc' : 'black', marginLeft: 10 }}>{value}</span>
                          ))
                          }
                          <ChevronRightIcon className={classes.cherveRightIcon} />
                        </div>
                      );
                    }

                  }}
                  inputValue={vehicleInputValue}
                  onInputChange={(e, val) => {
                    setVehicleInputValue(val.toUpperCase())
                    onSearchBlurVehicles(val,false)
                  }}
                  textFieldProps={
                    {
                      placeholder: "Eg: KA 02 Q 1234",
                      variant: "outlined",
                      margin: 'none',
                    }
                  }
                  multiple={false}
                />
              </div>

              {hiredTrip && values.vehicle && values.vehicle.id &&
                <div className={classes.widthV1}>
                  <div className={classes.titleV3}>Supplier Name*</div>
                  <Autocomplete
                    classes={{
                      listbox: classes.listBoxAutoCompelete,
                      option: classes.listBoxOption
                    }
                    }
                    disabled={tripId ? true : false}
                    className={classes.mtV1}
                    id="select-supplier-list"
                    name="supplier"
                    size="small"
                    value={supplierValue}
                    onOpen={() => {
                      setSupplierListOpen(true)
                    }}
                    onClose={() => {
                      setSupplierListOpen(false)
                    }}
                    //getOptionSelected={(option, value) => option.id === value.id}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        // timeout to avoid instant validation of the dialog's form.
                        setTimeout(() => {
                          setSupplierValue(null);
                          toggleAddSupplierOpen(true);
                          setSupplierDialogValue({
                            name: !checkNumberOnly(newValue) ? capitalizeTheWord(newValue) : "",
                            number: checkNumberOnly(newValue) ? newValue : "",
                          });
                        });
                      } else if (newValue && newValue.inputValue) {
                        setSupplierValue(null);
                        toggleAddSupplierOpen(true);
                        setSupplierDialogValue({
                          name: !checkNumberOnly(newValue.inputValue) ? capitalizeTheWord(newValue.inputValue) : "",
                          number: checkNumberOnly(newValue.inputValue) ? newValue.inputValue : "",
                        });
                      } else if (newValue && newValue.inputValue === '') {
                        setSupplierValue(null);
                        toggleAddSupplierOpen(true);
                        setSupplierDialogValue({
                          name: "",
                          number: "",
                        });
                      } else {
                        setSupplierValue(newValue && newValue.id ? newValue : null);
                      }
                    }}
                    required={true}
                    autoHighlight
                    options={trip && trip.createTripSuppliers && trip.createTripSuppliers.suppliers?trip.createTripSuppliers.suppliers:[]}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    getOptionValue={option => option.id}
                    getOptionLabel={(option) => {
                      if (typeof option === 'string') {
                        return '';
                      }
                      if (option.inputValue || !option.id) {
                        return '';
                      }
                      return option.vendorName;
                    }}
                    disableCloseOnSelect={false}
                    filterOptions={(options, params) => {
                      //const filtered = filter(options, params);
                      let filtered =[]
                      options.forEach((item,index)=>{
                        filtered.push({
                          ...item,
                          index:index
                        })
                      });
                      filtered.unshift({
                        inputValue: params.inputValue,
                        vendorName: params.inputValue && params.inputValue.length > 1 ? `Add Details for "${capitalizeTheWord(params.inputValue)}"` : `Add New Supplier`,
                      });
                      return filtered;
                    }}
                    renderOption={(option, { selected, inputValue }) => {
                      let matchesName, matchesNumber;
                      let partsName, partsNumber;
                      matchesName = match(option.vendorName, inputValue);
                      partsName = parse(option.vendorName, matchesName);
                      matchesNumber = match(option.vendorNumber, inputValue);
                      partsNumber = parse(option.vendorNumber, matchesNumber);

                      if (option && option.id) {
                        let list = trip && trip.createTripSuppliers && trip.createTripSuppliers.suppliers?trip.createTripSuppliers.suppliers:[]
                        if (option.index == list.length-1) {
                          return(<Fragment>
                                <Waypoint
                                  onEnter={() => {
                                    if(trip && trip.createTripSuppliers && trip.createTripSuppliers.maxPage && trip.createTripSuppliers.maxPage != currentPageNoSupplier){
                                      setCurrentPageNoSupplier(currentPageNoSupplier+1)
                                      fetchSuppliers(option.inputValue,true)
                                    }
                                  }}
                                />
                                <div className={classes.partyListItemV1}>
                                  <div className={classes.partyListItemFlex}>
                                    <span className={classes.driverListNameFlex}>{partsName.map((part, index) => {
                                      return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                        {part.text}
                                      </span>
                                      )
                                    })}</span>
                                    {option.vendorNumber && <>
                                      <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                      {partsNumber.map((part, index) => {
                                        return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                          {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                                        </span>
                                        )
                                      })}
                                    </>}
                                  </div>
                                </div>
                                </Fragment>)
                         }else{
                            return (
                              <div className={classes.partyListItemV1}>
                                  <div className={classes.partyListItemFlex}>
                                    <span className={classes.driverListNameFlex}>{partsName.map((part, index) => {
                                      return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                        {part.text}
                                      </span>
                                      )
                                    })}</span>
                                    {option.vendorNumber && <>
                                      <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                      {partsNumber.map((part, index) => {
                                        return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                          {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                                        </span>
                                        )
                                      })}
                                    </>}
                                  </div>
                              </div>
                            );
                        }

                      } else {
                        return (
                          // <div className={classes.partyAddListItem}>
                          //   <AddPersonIcon className={classes.addPersonIcon} />
                          //   <span>{option.vendorName}</span>
                          //   <ChevronRightIcon className={classes.cherveRightIcon} />
                          // </div>
                          <div className={classes.partyAddListItem}>
                            <AddPersonIcon className={classes.addPersonIcon} />
                            {partsName.map((part, index) => {
                              return (<span key={index} style={{ color: index == 0 ? '#0033cc' : 'black' }}>
                                {part.text}
                              </span>
                              )
                            })}
                            <ChevronRightIcon className={classes.cherveRightIcon} />
                          </div>
                        );
                      }

                    }}
                    onInputChange={(e, val) => {
                      onSearchBlurSuppliers(val,false)
                    }}
                    textFieldProps={
                      {
                        placeholder: "Eg: Suresh",
                        variant: "outlined",
                        margin: 'none',
                      }
                    }
                    multiple={false}
                  />
                </div>
              }

              {!hiredTrip && values.vehicle && values.vehicle.id &&
                <div className={classes.widthV1}>
                  <div className={classes.titleV3}>Driver Name*</div>
                  <Autocomplete
                    classes={{
                      listbox: classes.listBoxAutoCompelete,
                      option: classes.listBoxOption
                    }
                    }
                    className={classes.mtV1}
                    id="select-driver-list"
                    name="driver"
                    size="small"
                    disabled={(addLoad || tripId) ? true : false}
                    //defaultValue={driverDefaultValue?driverDefaultValue:null}
                    value={driverValue}
                    onOpen={() => {
                      setDriverListOpen(true)
                    }}
                    onClose={() => {
                      setDriverListOpen(false)
                    }}
                    getOptionSelected={(option, value) => option.id === value.id}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        // timeout to avoid instant validation of the dialog's form.
                        setTimeout(() => {
                          setDriverValue(null);
                          toggleAddDriverOpen(true);
                          setDriverDialogValue({
                            name: !checkNumberOnly(newValue) ? capitalizeTheWord(newValue) : "",
                            number: checkNumberOnly(newValue) ? newValue : "",
                          });
                        });
                      } else if (newValue && newValue.inputValue) {
                        setDriverValue(null);
                        toggleAddDriverOpen(true);
                        setDriverDialogValue({
                          name: !checkNumberOnly(newValue.inputValue) ? capitalizeTheWord(newValue.inputValue) : "",
                          number: checkNumberOnly(newValue.inputValue) ? newValue.inputValue : "",
                        });
                      } else if (newValue && newValue.inputValue === '') {
                        setDriverValue(null);
                        toggleAddDriverOpen(true);
                        setDriverDialogValue({
                          name: "",
                          number: "",
                        });
                      } else {
                        // if (newValue && newValue.status && newValue.status === 'ONTRIP') {
                        //   setDriverValue(null);
                        //   newValue.type = 'FD';
                        //   setCompleteTripValue(newValue);
                        //   setCompleteTripOpen(true);
                        // } else {
                        setDriverValue(newValue && newValue.id ? newValue : null);
                        // }
                      }

                    }}
                    required={false}
                    autoHighlight
                    options={trip && trip.createTripDrivers && trip.createTripDrivers.drivers?trip.createTripDrivers.drivers:[]}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    getOptionValue={option => option.id}
                    getOptionLabel={(option) => {
                      // e.g value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return '';
                      }
                      if (option.inputValue || !option.id) {
                        return '';
                      }
                      return option && option.name ? option.name : ''
                    }}
                    disableCloseOnSelect={false}
                    filterOptions={(options, params) => {
                      //const filtered = filter(options, params);
                      let filtered =[]
                      options.forEach((item,index)=>{
                        filtered.push({
                          ...item,
                          index:index
                        })
                      });
                      filtered.unshift({
                        inputValue: params.inputValue,
                        name: params.inputValue && params.inputValue.length > 1 ? `Add Details for "${capitalizeTheWord(params.inputValue)}"` : `Add New Driver`,
                      });
                      return filtered;
                    }}
                    filterSelectedOptions
                    renderOption={(option, { selected, inputValue }) => {
                      let matchesName, matchesNumber;
                      let partsName, partsNumber;
                      matchesName = match(option.name, inputValue);
                      partsName = parse(option.name, matchesName);
                      matchesNumber = match(option.contactNumber, inputValue);
                      partsNumber = parse(option.contactNumber, matchesNumber);

                      if (option && option.id) {
                        let list = trip && trip.createTripDrivers && trip.createTripDrivers.drivers?trip.createTripDrivers.drivers:[]
                        if (option.index == list.length-1) {
                          return(<Fragment>
                                <Waypoint
                                  onEnter={() => {
                                    if(trip && trip.createTripDrivers && trip.createTripDrivers.maxPage && trip.createTripDrivers.maxPage != currentPageNoDriver){
                                      setCurrentPageNoDriver(currentPageNoDriver+1)
                                      fetchSuppliers(option.inputValue,true)
                                    }
                                  }}
                                />
                                <div className={classes.driverListItem}>
                                  <div className={classes.driverListItemFlex}>
                                    <span className={classes.driverListNameFlex}>{partsName.map((part, index) => {
                                      return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                        {part.text}
                                      </span>
                                      )
                                    })}</span>
                                    {option.contactNumber && <>
                                      <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                      {partsNumber.map((part, index) => {
                                        return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                          {part.text}
                                        </span>
                                        )
                                      })}
                                    </>}
                                  </div>
                                  <div>
                                      <span className={classes.vehicleStatus}><FiberManualRecordIcon className={option.status && option.status == 'ONTRIP' ? classes.onTripBullet : classes.avilableBullet}></FiberManualRecordIcon>{option.status}</span>
                                  </div>
                                </div>
                                </Fragment>);
                        }else {
                        return (
                          <div className={classes.driverListItem}>
                            <div className={classes.driverListItemFlex}>
                              <span className={classes.driverListNameFlex}>{partsName.map((part, index) => {
                                return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                  {part.text}
                                </span>
                                )
                              })}</span>
                              {option.contactNumber && <>
                                <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                {partsNumber.map((part, index) => {
                                  return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                    {part.text}
                                  </span>
                                  )
                                })}
                              </>}
                            </div>
                            <div>
                                <span className={classes.vehicleStatus}><FiberManualRecordIcon className={option.status && option.status == 'ONTRIP' ? classes.onTripBullet : classes.avilableBullet}></FiberManualRecordIcon>{option.status}</span>
                            </div>
                          </div>
                        );
                      }
                      } else {
                        return (
                          // <div className={classes.partyAddListItem}>
                          //   <AddPersonIcon className={classes.addPersonIcon} />
                          //   <span>{option.name}</span>
                          //   <ChevronRightIcon className={classes.cherveRightIcon} />
                          // </div>
                          <div className={classes.partyAddListItem}>
                            <AddPersonIcon className={classes.addPersonIcon} />
                            {partsName.map((part, index) => {
                              return (<span key={index} style={{ color: index == 0 ? '#0033cc' : 'black' }}>
                                {part.text}
                              </span>
                              )
                            })}
                            <ChevronRightIcon className={classes.cherveRightIcon} />
                          </div>
                        );
                      }

                    }}
                    onInputChange={(e, val) => {
                      onSearchBlurDrivers(val,false)
                    }}
                    textFieldProps={
                      {
                        placeholder: "Eg: Harish",
                        variant: "outlined",
                        margin: 'none',
                      }
                    }
                    multiple={false}
                  />
                </div>
              }
            </div>
          </>
        ),
      },
      // {
      //   size: 12,
      //   visible: hiredTrip && values.vehicle && values.vehicle.id ? true : false,
      //   field: (
      //     <Autocomplete
      //       classes={{
      //         listbox: classes.listBoxAutoCompelete,
      //         option: classes.listBoxOption
      //       }
      //       }
      //       id="select-supplier-list"
      //       name="supplier"
      //       size="small"
      //       value={supplierValue}
      //       onOpen={() => {
      //         setSupplierListOpen(true)
      //       }}
      //       onClose={() => {
      //         setSupplierListOpen(false)
      //       }}
      //       //getOptionSelected={(option, value) => option.id === value.id}
      //       onChange={(event, newValue) => {
      //         if (typeof newValue === 'string') {
      //           // timeout to avoid instant validation of the dialog's form.
      //           setTimeout(() => {
      //             setSupplierValue(null);
      //             toggleAddSupplierOpen(true);
      //             setSupplierDialogValue({
      //               name: !checkNumberOnly(newValue) ? capitalizeTheWord(newValue) : "",
      //               number: checkNumberOnly(newValue) ? newValue : "",
      //             });
      //           });
      //         } else if (newValue && newValue.inputValue) {
      //           setSupplierValue(null);
      //           toggleAddSupplierOpen(true);
      //           setSupplierDialogValue({
      //             name: !checkNumberOnly(newValue.inputValue) ? capitalizeTheWord(newValue.inputValue) : "",
      //             number: checkNumberOnly(newValue.inputValue) ? newValue.inputValue : "",
      //           });
      //         } else if (newValue && newValue.inputValue === '') {
      //           setSupplierValue(null);
      //           toggleAddSupplierOpen(true);
      //           setSupplierDialogValue({
      //             name: "",
      //             number: "",
      //           });
      //         } else {
      //           setSupplierValue(newValue && newValue.id ? newValue : null);
      //         }
      //       }}
      //       required={true}
      //       autoHighlight
      //       options={vehicle && vehicle.vendors ? vehicle.vendors : []}
      //       selectOnFocus
      //       clearOnBlur
      //       handleHomeEndKeys
      //       getOptionValue={option => option.id}
      //       getOptionLabel={(option) => {
      //         if (typeof option === 'string') {
      //           return '';
      //         }
      //         if (option.inputValue || !option.id) {
      //           return '';
      //         }
      //         return option.vendorName;
      //       }}
      //       disableCloseOnSelect={false}
      //       filterOptions={(options, params) => {
      //         const filtered = filter(options, params);
      //         filtered.unshift({
      //           inputValue: params.inputValue,
      //           vendorName: params.inputValue && params.inputValue.length > 1 ? `Add Details for "${capitalizeTheWord(params.inputValue)}"` : `Add New Supplier`,
      //         });
      //         return filtered;
      //       }}
      //       renderOption={(option, { selected, inputValue }) => {
      //         let matchesName, matchesNumber;
      //         let partsName, partsNumber;
      //         matchesName = match(option.vendorName, inputValue);
      //         partsName = parse(option.vendorName, matchesName);
      //         matchesNumber = match(option.vendorNumber, inputValue);
      //         partsNumber = parse(option.vendorNumber, matchesNumber);

      //         if (option && option.id) {
      //           return (
      //             <div className={classes.partyListItem}>
      //               {partsName.map((part, index) => {
      //                 return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
      //                   {part.text}
      //                 </span>
      //                 )
      //               })}
      //               {option.vendorNumber && <>
      //                 <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
      //                 {partsNumber.map((part, index) => {
      //                   return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
      //                     {part.text}
      //                   </span>
      //                   )
      //                 })}
      //               </>}
      //             </div>
      //           );

      //         } else {
      //           return (
      //             <div className={classes.partyAddListItem}>
      //               <AddPersonIcon className={classes.addPersonIcon} />
      //               <span>{option.vendorName}</span>
      //               <ChevronRightIcon className={classes.cherveRightIcon} />
      //             </div>
      //           );
      //         }

      //       }}
      //       textFieldProps={
      //         {
      //           label: "Select a Supplier",
      //           placeholder: "Select a Supplier",
      //           variant: "outlined",
      //           margin: 'none',
      //         }
      //       }
      //       multiple={false}
      //     />
      //   ),
      // },
      // {
      //   size: 12,
      //   visible: !hiredTrip && values.vehicle && values.vehicle.id ? true : false,
      //   field: (
      //     <Autocomplete
      //       classes={{
      //         listbox: classes.listBoxAutoCompelete,
      //         option: classes.listBoxOption
      //       }
      //       }
      //       id="select-driver-list"
      //       name="driver"
      //       size="small"
      //       //defaultValue={driverDefaultValue?driverDefaultValue:null}
      //       value={driverValue}
      //       onOpen={() => {
      //         setDriverListOpen(true)
      //       }}
      //       onClose={() => {
      //         setDriverListOpen(false)
      //       }}
      //       getOptionSelected={(option, value) => option.id === value.id}
      //       onChange={(event, newValue) => {
      //         if (typeof newValue === 'string') {
      //           // timeout to avoid instant validation of the dialog's form.
      //           setTimeout(() => {
      //             setDriverValue(null);
      //             toggleAddDriverOpen(true);
      //             setDriverDialogValue({
      //               name: !checkNumberOnly(newValue) ? capitalizeTheWord(newValue) : "",
      //               number: checkNumberOnly(newValue) ? newValue : "",
      //             });
      //           });
      //         } else if (newValue && newValue.inputValue) {
      //           setDriverValue(null);
      //           toggleAddDriverOpen(true);
      //           setDriverDialogValue({
      //             name: !checkNumberOnly(newValue.inputValue) ? capitalizeTheWord(newValue.inputValue) : "",
      //             number: checkNumberOnly(newValue.inputValue) ? newValue.inputValue : "",
      //           });
      //         } else if (newValue && newValue.inputValue === '') {
      //           setDriverValue(null);
      //           toggleAddDriverOpen(true);
      //           setDriverDialogValue({
      //             name: "",
      //             number: "",
      //           });
      //         } else {
      //           if (newValue && newValue.status && newValue.status === 'ONTRIP') {
      //             setDriverValue(null);
      //             newValue.type = 'FD';
      //             setCompleteTripValue(newValue);
      //             setCompleteTripOpen(true);
      //           } else {
      //             setDriverValue(newValue && newValue.id ? newValue : null);
      //           }
      //         }

      //       }}
      //       required={false}
      //       autoHighlight
      //       options={vehicle && vehicle.drivers ? vehicle.drivers : []}
      //       selectOnFocus
      //       clearOnBlur
      //       handleHomeEndKeys
      //       getOptionValue={option => option.id}
      //       getOptionLabel={(option) => {
      //         // e.g value selected with enter, right from the input
      //         if (typeof option === 'string') {
      //           return '';
      //         }
      //         if (option.inputValue || !option.id) {
      //           return '';
      //         }
      //         return option && option.name ? option.name : ''
      //       }}
      //       disableCloseOnSelect={false}
      //       filterOptions={(options, params) => {
      //         const filtered = filter(options, params);
      //         filtered.unshift({
      //           inputValue: params.inputValue,
      //           name: params.inputValue && params.inputValue.length > 1 ? `Add Details for "${capitalizeTheWord(params.inputValue)}"` : `Add New Driver`,
      //         });
      //         return filtered;
      //       }}
      //       filterSelectedOptions
      //       renderOption={(option, { selected, inputValue }) => {
      //         let matchesName, matchesNumber;
      //         let partsName, partsNumber;
      //         matchesName = match(option.name, inputValue);
      //         partsName = parse(option.name, matchesName);
      //         matchesNumber = match(option.contactNumber, inputValue);
      //         partsNumber = parse(option.contactNumber, matchesNumber);

      //         if (option && option.id) {
      //           return (
      //             <div className={classes.partyListItem}>
      //               {partsName.map((part, index) => {
      //                 return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
      //                   {part.text}
      //                 </span>
      //                 )
      //               })}
      //               {option.contactNumber && <>
      //                 <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
      //                 {partsNumber.map((part, index) => {
      //                   return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
      //                     {part.text}
      //                   </span>
      //                   )
      //                 })}
      //               </>}
      //               <span>
      //                 <span className={classes.listRight}>
      //                   <span className={classes.vehicleStatus}><FiberManualRecordIcon className={option.status && option.status == 'ONTRIP' ? classes.onTripBullet : classes.avilableBullet}></FiberManualRecordIcon>{option.status}</span>
      //                 </span>
      //               </span>
      //             </div>
      //           );

      //         } else {
      //           return (
      //             <div className={classes.partyAddListItem}>
      //               <AddPersonIcon className={classes.addPersonIcon} />
      //               <span>{option.name}</span>
      //               <ChevronRightIcon className={classes.cherveRightIcon} />
      //             </div>
      //           );
      //         }

      //       }}
      //       textFieldProps={
      //         {
      //           label: "Select a Driver",
      //           placeholder: "Select a Driver",
      //           variant: "outlined",
      //           margin: 'none',
      //         }
      //       }
      //       multiple={false}
      //     />
      //   ),
      // },
      {
        size: 12,
        visible: hiredTrip ? false : false,
        inline: false,
        field: (
          <TextField
            label={'Driver Name'}
            placeholder={'Driver Name'}
            name="driverName"
            onChange={(e) => { setDriverName(e.target.value) }}
            margin="none"
            fullWidth={true}
            variant="outlined"
            size="small"
          />
        ),
      },
      {
        size: 12,
        visible: hiredTrip ? false : false,
        inline: false,
        field: (
          <TextField
            label={'Driver Contact Number'}
            placeholder={'Driver Contact Number'}
            onChange={(e) => { setDriverContactNumber(e.target.value) }}
            name="driverContactNumber"
            margin="none"
            InputProps={{
              startAdornment: <InputAdornment position="start">+ 91</InputAdornment>,
            }
            }
            fullWidth={true}
            variant="outlined"
            size="small"
          />
        ),
      },
      {
        size: 12,
        visible: true,
        field: (
          <>
            <div className={classes.divTripV1}>Route</div>
            <div className={classes.divRowV2}>
              <div className={classes.widthV1}>
                <div className={classes.titleV1}>Origin*</div>
                <Autocomplete
                  classes={{
                    listbox: classes.listBoxAutoCompelete,
                    option: classes.listBoxOption
                  }
                  }
                  className={classes.mtV1}
                  id="select-source-list"
                  name="origin"
                  size="small"
                  onOpen={() => {
                    setSourceListOpen(true)
                  }}
                  onClose={() => {
                    setSourceListOpen(false)
                  }}
                  onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                      // timeout to avoid instant validation of the dialog's form.
                      setSourceValue({
                        name: newValue ? capitalizeTheWord(newValue) : '',
                        state: '',
                        district: ''
                      })
                    } else if (newValue && newValue.inputValue) {
                      setSourceValue({
                        name: newValue.inputValue ? capitalizeTheWord(newValue.inputValue) : '',
                        state: '',
                        district: ''
                      })
                    } else if (newValue && newValue.inputValue === '') {
                    } else {
                      setSourceValue(newValue && newValue.name ? newValue : null);
                    }
                  }}
                  value={sourceValue}
                  //defaultValue={originDefaultValue?originDefaultValue:null}
                  getOptionSelected={(option, value) => option.name === value.name}
                  required={true}
                  autoHighlight
                  options={getGroupedLocation(user && user.allSuggestedOrginLocations ? user.allSuggestedOrginLocations : [], user && user.allLocations ? user.allLocations : [])}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  getOptionValue={option => option.name}
                  getOptionLabel={(option) => {
                    if (typeof option === 'string') {
                      return option;
                    }
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    return option && option.name ? option.name : ''
                  }}
                  disableCloseOnSelect={false}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    if (params.inputValue && params.inputValue.length > 1 && !checkNumberOnly(params.inputValue) && filtered && filtered.length == 0) {
                      filtered.unshift({
                        inputValue: params.inputValue,
                        name: params.inputValue && params.inputValue.length > 1 ? `Select "${capitalizeTheWord(params.inputValue)}"` : ``,
                        add: true
                      });
                    }
                    return filtered;
                  }}
                  filterSelectedOptions
                  groupBy={(option) => option.mapper}
                  renderOption={(option, { selected, inputValue }) => {
                    let matchesName = match(option.name, inputValue);
                    let partsName = parse(option.name, matchesName);
                    let addLocation = [];

                    if (option && option.name && option.name.includes("Select")) {
                      addLocation = option.name.split(/"/);
                    }

                    addLocation.pop();

                    if (option && option.name && !option.add) {
                      return (
                        <div className={classes.partyListItem}>
                          {partsName.map((part, index) => {
                            return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                              {part.text}
                            </span>
                            )
                          })}
                          {option.state && <>
                            <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                            {option.state}
                          </>}
                        </div>
                      );

                    } else {
                      return (
                        <div className={classes.partyAddListItem}>
                          <LocationOnOutlinedIcon className={classes.addPersonIcon} />
                          {addLocation.length > 0 && addLocation.map((value, index) => (
                            <span style={{ color: index == 0 ? '#0033cc' : 'black' }} >{value}</span>
                          ))}
                          <ChevronRightIcon className={classes.cherveRightIcon} />
                        </div>
                      );
                    }
                  }}
                  textFieldProps={
                    {
                      placeholder: "Eg: Bangalore",
                      variant: "outlined",
                      margin: 'none',
                    }
                  }
                  multiple={false}
                />
              </div>
              <div className={classes.widthV1}>
                <div className={classes.titleV1}>Destination*</div>
                <Autocomplete
                  classes={{
                    listbox: classes.listBoxAutoCompelete,
                    option: classes.listBoxOption
                  }
                  }
                  className={classes.mtV1}
                  id="select-destination-list"
                  name="destination"
                  size="small"
                  value={destinationValue}
                  onOpen={() => {
                    setDestinationListOpen(true)
                  }}
                  onClose={() => {
                    setDestinationListOpen(false)
                  }}
                  groupBy={(option) => option.mapper}
                  onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                      // timeout to avoid instant validation of the dialog's form.
                      setDestinationValue({
                        name: newValue ? capitalizeTheWord(newValue) : '',
                        state: '',
                        district: ''
                      })
                    } else if (newValue && newValue.inputValue) {
                      setDestinationValue({
                        name: newValue.inputValue ? capitalizeTheWord(newValue.inputValue) : '',
                        state: '',
                        district: ''
                      })
                    } else if (newValue && newValue.inputValue === '') {
                    } else {
                      setDestinationValue(newValue && newValue.name ? newValue : null);
                    }
                    //setDestinationValue(newValue)
                  }}
                  //defaultValue={destinationDefaultValue?destinationDefaultValue:null}
                  getOptionSelected={(option, value) => option.name === value.name}
                  required={true}
                  autoHighlight
                  options={getGroupedLocation(user && user.allSuggestedDestinationLocations ? user.allSuggestedDestinationLocations : [], user && user.allLocations ? user.allLocations : [])}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  getOptionValue={option => option.name}
                  filterSelectedOptions
                  getOptionLabel={(option) => {
                    // e.g value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return option;
                    }
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    return option && option.name ? option.name : ''
                  }}
                  disableCloseOnSelect={false}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    if (params.inputValue && params.inputValue.length > 1 && !checkNumberOnly(params.inputValue) && filtered && filtered.length == 0) {
                      filtered.unshift({
                        inputValue: params.inputValue,
                        name: params.inputValue && params.inputValue.length > 1 ? `Select "${capitalizeTheWord(params.inputValue)}"` : ``,
                        add: true
                      });
                    }
                    return filtered;
                  }}
                  renderOption={(option, { selected, inputValue }) => {
                    let matchesName = match(option.name, inputValue);
                    let partsName = parse(option.name, matchesName);
                    let addLocation = [];

                    if (option && option.name && option.name.includes("Select")) {
                      addLocation = option.name.split(/"/);
                    }

                    addLocation.pop();

                    if (option && option.name && !option.add) {
                      return (
                        <div className={classes.partyListItem}>
                          {partsName.map((part, index) => {
                            return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                              {part.text}
                            </span>
                            )
                          })}
                          {option.state && <>
                            <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                            {option.state}
                          </>}
                        </div>
                      );

                    } else {
                      return (
                        <div className={classes.partyAddListItem}>
                          <LocationOnOutlinedIcon className={classes.addPersonIcon} />
                          {addLocation.length > 0 && addLocation.map((value, index) => (
                            <span style={{ color: index == 0 ? '#0033cc' : 'black' }} >{value}</span>
                          ))}
                          <ChevronRightIcon className={classes.cherveRightIcon} />
                        </div>
                      );
                    }
                  }}
                  textFieldProps={
                    {
                      placeholder: "Eg: Delhi",
                      variant: "outlined",
                      margin: 'none',
                    }
                  }
                  multiple={false}
                />
              </div>
            </div>
          </>
        ),
      },
      // {
      //   size: 12,
      //   visible: true,
      //   field: (
      //     <Autocomplete
      //       classes={{
      //         listbox: classes.listBoxAutoCompelete,
      //         option: classes.listBoxOption
      //       }
      //       }
      //       id="select-destination-list"
      //       name="destination"
      //       size="small"
      //       value={destinationValue}
      //       onOpen={() => {
      //         setDestinationListOpen(true)
      //       }}
      //       onClose={() => {
      //         setDestinationListOpen(false)
      //       }}
      //       onChange={(event, newValue) => {
      //         if (typeof newValue === 'string') {
      //           // timeout to avoid instant validation of the dialog's form.
      //           setDestinationValue({
      //             name: newValue ? capitalizeTheWord(newValue) : '',
      //             state: '',
      //             district: ''
      //           })
      //         } else if (newValue && newValue.inputValue) {
      //           setDestinationValue({
      //             name: newValue.inputValue ? capitalizeTheWord(newValue.inputValue) : '',
      //             state: '',
      //             district: ''
      //           })
      //         } else if (newValue && newValue.inputValue === '') {
      //         } else {
      //           setDestinationValue(newValue && newValue.name ? newValue : null);
      //         }
      //         //setDestinationValue(newValue)
      //       }}
      //       //defaultValue={destinationDefaultValue?destinationDefaultValue:null}
      //       getOptionSelected={(option, value) => option.name === value.name}
      //       required={true}
      //       autoHighlight
      //       options={user && user.allLocations ? user.allLocations : []}
      //       selectOnFocus
      //       clearOnBlur
      //       handleHomeEndKeys
      //       getOptionValue={option => option.name}
      //       filterSelectedOptions
      //       getOptionLabel={(option) => {
      //         // e.g value selected with enter, right from the input
      //         if (typeof option === 'string') {
      //           return option;
      //         }
      //         if (option.inputValue) {
      //           return option.inputValue;
      //         }
      //         return option && option.name ? option.name : ''
      //       }}
      //       disableCloseOnSelect={false}
      //       filterOptions={(options, params) => {
      //         const filtered = filter(options, params);
      //         if (params.inputValue && params.inputValue.length > 1 && !checkNumberOnly(params.inputValue) && filtered && filtered.length == 0) {
      //           filtered.unshift({
      //             inputValue: params.inputValue,
      //             name: params.inputValue && params.inputValue.length > 1 ? `Add "${capitalizeTheWord(params.inputValue)}"` : ``,
      //             add: true
      //           });
      //         }
      //         return filtered;
      //       }}
      //       renderOption={(option, { selected, inputValue }) => {
      //         let matchesName = match(option.name, inputValue);
      //         let partsName = parse(option.name, matchesName);
      //         if (option && option.name && !option.add) {
      //           return (
      //             <div className={classes.partyListItem}>
      //               {partsName.map((part, index) => {
      //                 return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
      //                   {part.text}
      //                 </span>
      //                 )
      //               })}
      //               {option.state && <>
      //                 <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
      //                 {option.state}
      //               </>}
      //             </div>
      //           );

      //         } else {
      //           return (
      //             <div className={classes.partyAddListItem}>
      //               <AddLocationIcon className={classes.addPersonIcon} />
      //               <span>{option.name}</span>
      //               <ChevronRightIcon className={classes.cherveRightIcon} />
      //             </div>
      //           );
      //         }
      //       }}
      //       textFieldProps={
      //         {
      //           label: "Select a Destination",
      //           placeholder: "Select a Destination",
      //           variant: "outlined",
      //           margin: 'none',
      //         }
      //       }
      //       multiple={false}
      //     />
      //   ),
      // },
      {
        size: 12,
        visible: true,
        inline: false,
        field: (
          <>
            <div className={classes.divTripV2}>Billing Information</div>
            <Radios
              label="Party Billing Type"
              name="partyBillingType"
              required={true}
              formControlProps={{
                margin: 'none',
                className: classes.billingTypeRadio,
                fullWidth: true
              }}
              formControlLabelProps={{
                className: classes.billingTypeLabel
              }}
              className={classes.mtV2}
              onChange={(e) => { setPartyBillingType(e.target.value) }}
              formLabelProps={{}}
              radioGroupProps={{ row: true }}
              data={[
                { value: 'Fixed', label: 'Fixed' },
                { value: 'Per Tonne', label: 'Per Tonne' },
                { value: 'Per KG', label: 'Per Kg' },
                { value: 'Per KM', label: 'Per Km' },
                { value: 'Per Trip', label: 'Per Trip' },
                { value: 'Per Day', label: 'Per Day' },
                { value: 'Per Hour', label: 'Per Hour' },
                { value: 'Per Litre', label: 'Per Litre' },
                { value: 'Per Bag', label: 'Per Bag' }
              ]}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: partyBillingType == 'Fixed',
        inline: false,
        field: (
          <>
            <div className={classes.titleV2}>Party Freight Amount*</div>
            <AmountInput
              // label="Enter Party Freight Amount"
              placeholder="Eg: 45,000"
              name="amount"
              margin="none"
              fullWidth={true}
              variant="outlined"
              onChange={(e) => {
                setFreightAmount(e.target.value);
                //numberWithCommasInput(e,setFreightAmount)
              }
              }
              className={classes.textV1}
              size="small"
              fieldProps={{
                //parse: value => value && numberWithCommas(value)
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
              }}
              required={true}
            />
          </>
        ),
      },
      {
        size: 6,
        visible: partyBillingType !== 'Fixed',
        inline: false,
        field: (
          <>
            <div className={classes.divRowV4}>
              <div className={classes.widthV1}>
                <div className={classes.titleV2}>{unitsPriceLabel}</div>
                <AmountInput
                  // label={unitsPriceLabel}
                  placeholder={unitsPriceLabel}
                  name="unitPrice"
                  onChange={(e) => {
                    //numberWithCommasInput(e,setUnitPrice)
                    setUnitPrice(e.target.value);
                  }}
                  fieldProps={{
                    parse: value => value && numberWithCommas(value)
                  }}
                  fullWidth={true}
                  variant="outlined"
                  size="small"
                  required={true}
                  className={classes.mtV1}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">&#8377;</InputAdornment>
                  }}
                />
              </div>
              <div className={classes.widthV1}>
                <div className={classes.titleV2}>{totalUnitsLabel}</div>
                <TextInputState
                  // label={totalUnitsLabel}
                  placeholder={totalUnitsLabel}
                  onChange={(e) => { setTotalUnits(e.target.value) }}
                  name="totalUnits"
                  fullWidth={true}
                  variant="outlined"
                  size="small"
                  required={true}
                  className={classes.mtV1}
                />
              </div>
            </div>
          </>
        ),
      },
      // {
      //   size: 3,
      //   visible: partyBillingType !== 'Fixed',
      //   inline: false,
      //   field: (
      //     <>
      //       <div className={classes.titleV2}>{totalUnitsLabel}</div>
      //       <TextInputState
      //         // label={totalUnitsLabel}
      //         placeholder={totalUnitsLabel}
      //         onChange={(e) => { setTotalUnits(e.target.value) }}
      //         name="totalUnits"
      //         fullWidth={true}
      //         variant="outlined"
      //         size="small"
      //         required={true}
      //         className={classes.mtV1}
      //       />
      //     </>
      //   ),
      // },
      {
        size: 12,
        visible: partyBillingType !== 'Fixed',
        inline: false,
        field: (
          <div className={classes.widthV1}>
            <Paper className={clsx(classes.unitCard, classes.freightCard)}>
              <div><span className={classes.unitDesc}>{freightAmountCard}</span></div>
              <div><span className={classes.unitAmount}>{numberFormat(Number(values.totalUnits) * Number(replaceCommas(values.unitPrice)))}</span></div>
            </Paper>
          </div>
        ),
      },
      // {
      //   size: 6,
      //   visible: true,
      //   inline: false,
      //   field: (
      //     <AmountInput
      //       // label={"Start KMs"}
      //       placeholder={'Start readings'}
      //       name="startOdometerReading"
      //       margin="none"
      //       onChange={(e) => {
      //         //numberWithCommasInput(e,setStartOdometerReading)
      //         setStartOdometerReading(e.target.value);
      //       }}
      //       fullWidth={true}
      //       variant="outlined"
      //       InputProps={{
      //         endAdornment: <InputAdornment position="start">KMs</InputAdornment>,
      //       }
      //       }
      //       size="small"
      //       margin="none"
      //     />
      //   ),
      // },
      {
        size: 12,
        visible: hiredTrip ? true : false,
        inline: false,
        field: (
          <>
            <Radios
              label="Supplier Billing Type"
              name="vendorBillingType"
              required={true}
              formControlProps={{
                margin: 'none',
                className: classes.billingTypeRadio,
                fullWidth: true
              }}
              onChange={(e) => { setVendorBillingType(e.target.value) }}
              formControlLabelProps={{
                className: classes.supplierBillingTypeLabel
              }}
              radioGroupProps={{ row: true }}
              data={[
                { value: 'Fixed', label: 'Fixed' },
                { value: 'Per Tonne', label: 'Per Tonne' },
                { value: 'Per KG', label: 'Per Kg' },
                { value: 'Per KM', label: 'Per Km' },
                { value: 'Per Trip', label: 'Per Trip' },
                { value: 'Per Day', label: 'Per Day' },
                { value: 'Per Hour', label: 'Per Hour' },
                { value: 'Per Litre', label: 'Per Litre' },
                { value: 'Per Bag', label: 'Per Bag' }
              ]}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: vendorBillingType == 'Fixed' && hiredTrip,
        inline: false,
        field: (
          <>
            <div className={classes.titleV2}>Truck Hire Cost*</div>
            <AmountInput
              // label="Truck Hire Cost"
              placeholder="Eg: 45,000"
              name="truckHireCost"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                //numberWithCommasInput(e,setTruckHireCost)
                setTruckHireCost(e.target.value);
              }}
              fieldProps={{
                parse: value => value && numberWithCommas(value)
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
              }}
              required={true}
              className={classes.dateV1}
            />
          </>
        ),
      },
      {
        size: 6,
        visible: vendorBillingType !== 'Fixed' && hiredTrip,
        inline: false,
        field: (
          <>
            <div className={classes.divRowV4}>
              <div className={classes.widthV1}>
                <div className={classes.titleV2}>{vendorUnitsPriceLabel}</div>
                <AmountInput
                  // label={vendorUnitsPriceLabel}
                  placeholder={vendorUnitsPriceLabel}
                  name="vendorUnitPrice"
                  margin="none"
                  onChange={(e) => {
                    //numberWithCommasInput(e,setVendorUnitPrice)
                    setVendorUnitPrice(e.target.value);
                  }}
                  fieldProps={{
                    parse: value => value && numberWithCommas(value)
                  }}
                  fullWidth={true}
                  variant="outlined"
                  size="small"
                  className={classes.mtV1}
                  required={true}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                  }}
                />
              </div>

              <div className={classes.widthV1}>
                <div className={classes.titleV2}>{vendorTotalUnitsLabel}</div>
                <TextInputState
                  // label={vendorTotalUnitsLabel}
                  placeholder={vendorTotalUnitsLabel}
                  name="vendorTotalUnits"
                  onChange={(e) => { setVendorTotalUnits(e.target.value) }}
                  fullWidth={true}
                  variant="outlined"
                  size="small"
                  className={classes.mtV1}
                  required={true}
                />
              </div>
            </div>
          </>
        ),
      },
      // {
      //   size: 6,
      //   visible: vendorBillingType !== 'Fixed' && hiredTrip,
      //   inline: false,
      //   field: (
      //     <>
      //       <div className={classes.titleV2}>{vendorTotalUnitsLabel}</div>
      //       <TextInputState
      //         // label={vendorTotalUnitsLabel}
      //         placeholder={vendorTotalUnitsLabel}
      //         name="vendorTotalUnits"
      //         onChange={(e) => { setVendorTotalUnits(e.target.value) }}
      //         fullWidth={true}
      //         variant="outlined"
      //         size="small"
      //         className={classes.mtV1}
      //         required={true}
      //       />
      //     </>
      //   ),
      // },
      {
        size: 12,
        visible: vendorBillingType !== 'Fixed' && hiredTrip,
        inline: false,
        field: (
          <div className={classes.widthV1}>
            <Paper className={clsx(classes.unitCard, classes.truckHireCard)}>
              <div><span className={classes.unitDesc}>{truckHireCostCard}</span></div>
              <div><span className={classes.unitAmount}>{numberFormat(Number(values.vendorTotalUnits) * Number(replaceCommas(values.vendorUnitPrice)))}</span></div>
            </Paper>
          </div>
        ),
      },
      {
        size: 12,
        visible: true,
        field: (
          <>
            <div className={classes.divRowV1}>
              <div className={classes.widthV1}>
                <div className={classes.titleV1}>Start Date*</div>
                <DatePicker
                  disableFuture
                  name="startDate"
                  margin="none"
                  variant="inline"
                  minDate={values.party && values.party.openingBalanceDate?new Date(Number(values.party.openingBalanceDate)*1000): new Date("01-01-1900")}
                  fullWidth={true}
                  onChange={(date) => { setTripStartDate(date) }}
                  inputVariant="outlined"
                  size="small"
                  format="dd-MM-yyyy"
                  // label="Start Date"
                  placeholder="Select Start Date"
                  dateFunsUtils={DateFnsUtils}
                  InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                  className={classes.mtV1}
                />
              </div>

              <div className={classes.widthV1}>
                <div className={classes.titleV1}>Start Kms Reading</div>
                <AmountInput
                  // label={"Start KMs"}
                  placeholder={'Start readings'}
                  name="startOdometerReading"
                  onChange={(e) => {
                    //numberWithCommasInput(e,setStartOdometerReading)
                    setStartOdometerReading(e.target.value);
                  }}
                  fullWidth={true}
                  variant="outlined"
                  InputProps={{
                    endAdornment: <InputAdornment position="start">KMs</InputAdornment>,
                  }}
                  size="small"
                  className={classes.mtV1}
                />
              </div>
            </div>

          </>
        ),
      },
      {
        size: 6,
        visible: tripId && (tripStatus && (tripStatus == "COMPLETED" || tripStatus == "POD_RECEIVED" || tripStatus == "POD_SUBMITTED")) ? true : false,
        field: (
          <div>
            <div className={classes.titleV1}>Completed Date</div>
            <DatePicker
              disableFuture
              name="completedDate"
              margin="none"
              minDate={values && values.startDate ? new Date(values.startDate) : null}
              variant="inline"
              fullWidth={true}
              onChange={(date) => { setTripCompletedDate(date) }}
              inputVariant="outlined"
              size="small"
              format="dd-MM-yyyy"
              // label="End Date"
              placeholder="Select a End Date"
              dateFunsUtils={DateFnsUtils}
              InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
              className={classes.mtV1}
            />
          </div>
        ),
      },
      {
        size: 6,
        visible: tripId && (tripStatus && (tripStatus == "COMPLETED" || tripStatus == "POD_RECEIVED" || tripStatus == "POD_SUBMITTED")) ? true : false,
        inline: false,
        field: (
          <>
            <div className={classes.titleV1}>End KM Reading</div>
            <AmountInput
              // label={"End KMs"}
              placeholder={'End readings'}
              name="endOdometerReading"
              onChange={(e) => {
                //numberWithCommasInput(e,setEndOdometerReading)
                setEndOdometerReading(e.target.value);
              }}
              margin="none"
              fullWidth={true}
              variant="outlined"
              InputProps={{
                endAdornment: <InputAdornment position="start">KMs</InputAdornment>,
              }
              }
              size="small"
              className={classes.mtV1}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: tripId && (tripStatus && (tripStatus == "POD_RECEIVED" || tripStatus == "POD_SUBMITTED")) ? true : false,
        field: (
          <>
            <div className={classes.divRowV2}>
              <div className={classes.widthV1}>
                <div className={classes.titleV1}>POD Received Date</div>
                <DatePicker
                  disableFuture
                  name="podReceivedDate"
                  margin="none"
                  minDate={values && values.startDate ? new Date(values.startDate) : null}
                  variant="inline"
                  fullWidth={true}
                  onChange={(date) => { setPodReceivedDate(date) }}
                  inputVariant="outlined"
                  size="small"
                  format="dd-MM-yyyy"
                  // label="POD Received Date"
                  placeholder="Select a POD Received Date"
                  dateFunsUtils={DateFnsUtils}
                  InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                  className={classes.mtV1}
                />
              </div>

              <div className={classes.widthV1}>
                <div className={classes.titleV1}>POD Submitted Date</div>
                <DatePicker
                  disableFuture
                  name="podSubmittedDate"
                  margin="none"
                  variant="inline"
                  minDate={values && values.startDate ? new Date(values.startDate) : null}
                  fullWidth={true}
                  onChange={(date) => { setPodSubmittedDate(date) }}
                  inputVariant="outlined"
                  size="small"
                  format="dd-MM-yyyy"
                  // label="POD Submitted Date"
                  placeholder="Select a POD Submitted Date"
                  dateFunsUtils={DateFnsUtils}
                  InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                  className={classes.mtV1}
                />
              </div>
            </div>

          </>
        ),
      },
      // {
      //   size: 12,
      //   visible: tripId && (tripStatus && (tripStatus == "POD_SUBMITTED")) ? true : false,
      //   field: (
      //     <div>
      //       <div className={classes.titleV2}>POD Submitted Date</div>
      //       <DatePicker
      //         disableFuture
      //         name="podSubmittedDate"
      //         margin="none"
      //         variant="inline"
      //         minDate={values && values.startDate ? new Date(values.startDate) : null}
      //         fullWidth={true}
      //         onChange={(date) => { setPodSubmittedDate(date) }}
      //         inputVariant="outlined"
      //         size="small"
      //         format="dd-MM-yyyy"
      //         // label="POD Submitted Date"
      //         placeholder="Select a POD Submitted Date"
      //         dateFunsUtils={DateFnsUtils}
      //         className={classes.dateV1}
      //       />
      //     </div>
      //   ),
      // },
      {
        size: 12,
        visible: !moreDetailFlag,
        field: (
          <>
            <Button className={classes.addMoreDetailsButton} variant='outlined' onClick={() => setMoreDetailFlag(true)}>
              Add More Details
            </Button>
          </>
        ),
      },
      {
        size: 12,
        visible: moreDetailFlag,
        field: (
          <>
            <div className={classes.divTripV1}>More Details</div>
            <div className={classes.divRowV2}>
              <div className={classes.widthV1}>
                <div className={classes.titleV1}>LR No</div>
                <TextInputState
                  placeholder='Enter LR Number'
                  name="lrNo"
                  margin="none"
                  fullWidth={true}
                  variant="outlined"
                  onChange={(e) => setLrNoValue(e.target.value)}
                  size="small"
                  className={classes.textFieldV1}
                />
              </div>
              <div className={classes.widthV1}>
                <div className={classes.titleV1}>Material</div>
                <TextInputState
                  placeholder='Enter Material Name'
                  name="material"
                  margin="none"
                  fullWidth={true}
                  onChange={(e) => setMaterialValue(e.target.value)}
                  variant="outlined"
                  size="small"
                  className={classes.mtV1}
                />
              </div>
            </div>
          </>
        ),
      },
      {
        size: 12,
        visible: moreDetailFlag,
        field: (
          <>
            <div className={classes.divRowV3}>
              <div className={classes.widthV1}>
                <div className={classes.titleV1}>Notes</div>
                <TextInputState
                  placeholder="Notes"
                  name="notes"
                  variant="outlined"
                  size="small"
                  multiline={true}
                  rows={3}
                  rowsMax={3}
                  className={classes.textNote}
                  onChange={(e) => setNoteValue(e.target.value)}
                  InputProps={{
                    startAdornment: <InputAdornment position="start" className={classes.inputAdornmentV1}> <NotesIcon /></InputAdornment>
                  }}
                />
              </div>
            </div>
          </>
        )
      }
    ]
  };



  return (
    <>
      {open && <RightSideBar
        rightSideBarOpen={open}
        sideBarTitle={sideBarTitleValue ? sideBarTitleValue : 'Add/Edit Trip'}
        sideBarType="form"
        fromAddTrip={true}
        handleSubmit={event => submit(event)}
        toggleRightSideBar={onConfirm}
        onValidate={validate(initialValues)}
        confirmText={"Save Load"}
      >
        <div className={classes.divTrip}>Trip Details</div>
        <Form
          onSubmit={onSubmit}
          //keepDirtyOnReinitialize
          initialValues={initialValues}
          validate={validate}
          render={({ handleSubmit, form, submitting, pristine, values }) => {
            submit = handleSubmit; formValues = values; return (
              <form onSubmit={handleSubmit} noValidate>
                <Grid container alignItems="flex-start" spacing={3}>
                  {getFormFields(values).map((item, idx) => item.visible ? (
                    <Grid item xs={item.size} key={idx} className={classes.ptV1}>
                      {item.field}
                    </Grid>
                  ) : null)}
                </Grid>
                {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
              </form>
            )
          }}
        />
      </RightSideBar>}
      {addPartyOpen && <AddParty open={addPartyOpen} defaultName={partyDialogValue.name} defaultNumber={partyDialogValue.number} onClose={handleAddPartyClose} onSave={handlePartySave} />}
      {addSupplierOpen && <AddSupplier open={addSupplierOpen} defaultName={supplierDialogValue.name} defaultNumber={supplierDialogValue.number} onClose={handleAddSupplierClose} onSave={handleSupplierSave} />}
      {completeTripOpen && <TripCompleteActionDialog tripId={completeTripValue.tripId} open={completeTripOpen} onClose={handleTripCompleteActionClose} onSave={handleTripCompleteActionConfirm} />}
      {addDriverOpen && <AddDriver open={addDriverOpen} defaultName={driverDialogValue.name} defaultNumber={driverDialogValue.number} onClose={handleAddDriverClose} type={'driver'} onConfirm={handleDriverSave} fromTrip={true} />}
      {addVehicleOpen && <AddVehicle open={addVehicleOpen} defaultVechicleNumber={vehicleDialogValue.vehicleNumber} onClose={handleAddVehicleClose} onSave={handleVehicleSave} />}
    </>
  );
}
AddEditLoadSideBar.propTypes = {
  //tripId: PropTypes.any.isRequired,
};
const AddEditTripSideBarWithRouter = withRouter(AddEditLoadSideBar);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getJourneyDetails(tripId, onSuccess, onError)),
  dispatchGetPartyListAction: (data, onSuccess, onFailure) => dispatch(getPartyListV2(data, onSuccess, onFailure)),
  dispatchGetVehicleListAction: (data, onSuccess, onFailure) => dispatch(getVehicleListV2(data, onSuccess, onFailure)),
  dispatchGetSupplierListAction: (data, onSuccess, onFailure) => dispatch(getSupplierListV2(data, onSuccess, onFailure)),
  dispatchGetDriverListAction: (data, onSuccess, onFailure) => dispatch(getDriverListV2(data, onSuccess, onFailure)),
  dispatchGetVehicleLedgerAction: (requestData, onSuccess, onFailure) => { dispatch(getVehicleLedgerData(requestData, onSuccess, onFailure)) },
  dispatchGetAllLocations: (onSuccess, onFailure) => { dispatch(getAllLocations(onSuccess, onFailure)) },
  dispatchGetAllSuggestedOrginLocations: (data, onSuccess, onFailure) => { dispatch(getSuggestedOrginLocations(data, onSuccess, onFailure)) },
  dispatchGetAllSuggestedDestLocations: (data, onSuccess, onFailure) => { dispatch(getSuggestedDestinationLocations(data, onSuccess, onFailure)) },
  dispatchCreateLoad: (id,data, onSuccess, onFailure) => { dispatch(createLoad(id,data, onSuccess, onFailure)) },
  dispatchGetAllDrivers: (onSuccess, onFailure) => dispatch(getAllDrivers(null, onSuccess, onFailure)),
  dispatchGetAllVendors: (onSuccess, onFailure) => dispatch(getAllVendors(null, onSuccess, onFailure)),
  dispatchUpdateTrip: (tripId, trip, onSuccess, onError) => {
    dispatch(updateTrip(tripId, trip, onSuccess, onError));
  },
  dispatchEditVendorExpense: (expenseId, request, onSuccess, onFailure) =>
    dispatch(editVendorExpense(expenseId, request, onSuccess, onFailure)),
  dispatchEmptyPartyList: () => dispatch(emptyPartyList()),
  dispatchChatView: (value) => dispatch(updateChatView(value)),
  dispatchUpdateNoteTrip: (tripId, noteId, data, onSuccess, onFailure) => {
    dispatch(updateNoteTrip(tripId, noteId, data, onSuccess, onFailure))
  },
  dispatchAddNoteTrip: (tripId, data, onSuccess, onError) => {
    dispatch(addNewNoteTrip(tripId, data, onSuccess, onError))
  },
  dispatchDeleteTripNote: (tripId, noteId, onSuccess, onError) => {
    dispatch(deleteTripNote(tripId, noteId, onSuccess, onError))
  },
  dispatchGetTripLedgerAction: (requestData, onSuccess, onError) =>
    dispatch(
      getTripLedgerData(
        requestData, onSuccess, onError
      )
    ),
  dispatchUpdateModal: (value) => {
    dispatch(updateFreeTrialModal(value))
  },
  dispatchFetchTripDefaults: (onSuccess, onError) => {
    dispatch(fetchTripDefaults(onSuccess, onError))
  },
  dispatchAddVendorExpense: (request, onSuccess, onFailure) => {
    dispatch(addVendorExpense(request, onSuccess, onFailure))
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditTripSideBarWithRouter);
